var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-3",
    cx: 253.04,
    cy: 335.01,
    rx: 233.2,
    ry: 134.64,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-3",
    cx: 321.15,
    cy: 262.37,
    rx: 34.19,
    ry: 19.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M373.94,285.12,441,323.83a6.67,6.67,0,0,0,6.06,0L457.24,318c1.68-1,1.68-2.53,0-3.5l-67.05-38.71a6.67,6.67,0,0,0-6.06,0l-10.19,5.88C372.27,282.58,372.27,284.15,373.94,285.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M156.65,399.15l92.68,53.51a9.15,9.15,0,0,0,8.28,0l147-84.89c2.28-1.32,2.28-3.46,0-4.78L312,309.48a9.15,9.15,0,0,0-8.28,0l-147,84.89C154.37,395.69,154.37,397.83,156.65,399.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M140.56,339.62l-18.91-10.91a9.13,9.13,0,0,0-8.27,0L51.76,364.28a9.15,9.15,0,0,1-8.28,0l-7.25-4.19c-2.29-1.32-2.29-3.46,0-4.78L229.86,243.52a9.15,9.15,0,0,1,8.28,0l7.25,4.19c2.29,1.32,2.29,3.46,0,4.78l-61.61,35.57c-2.29,1.32-2.29,3.46,0,4.78l18.9,10.91c2.29,1.32,2.29,3.46,0,4.78l-53.85,31.09A9.13,9.13,0,0,1,140.56,339.62Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.47,389.06l88.81,51.27a4.88,4.88,0,0,0,4.39,0l143.17-82.65a1.34,1.34,0,0,0,0-2.53L310,303.88a4.85,4.85,0,0,0-4.39,0L162.47,386.53A1.34,1.34,0,0,0,162.47,389.06Zm132.17-75.2a3,3,0,0,1,3.16.35l83.33,48.1a1.14,1.14,0,0,1,0,2.17L267.28,430.2a4.15,4.15,0,0,1-3.76,0l-83.34-48.1a1.14,1.14,0,0,1,0-2.17Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.47,389.06l88.81,51.27a4.88,4.88,0,0,0,4.39,0l143.17-82.65a1.34,1.34,0,0,0,0-2.53L310,303.88a4.85,4.85,0,0,0-4.39,0L162.47,386.53A1.34,1.34,0,0,0,162.47,389.06Zm132.17-75.2a3,3,0,0,1,3.16.35l83.33,48.1a1.14,1.14,0,0,1,0,2.17L267.28,430.2a4.15,4.15,0,0,1-3.76,0l-83.34-48.1a1.14,1.14,0,0,1,0-2.17Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.94,414.61a8.68,8.68,0,0,1-4.25-1h0a2.93,2.93,0,0,1,0-5.48,9.26,9.26,0,0,1,8.51,0,2.93,2.93,0,0,1,0,5.48A8.69,8.69,0,0,1,213.94,414.61Zm0-6.54a7.78,7.78,0,0,0-3.75.89,2,2,0,0,0,0,3.76h0a8.35,8.35,0,0,0,7.51,0,2,2,0,0,0,0-3.76A7.79,7.79,0,0,0,213.94,408.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1,355.31a4.92,4.92,0,0,1,1.94,3.63v2.9a4.87,4.87,0,0,1-2.2,3.81L255.68,448.29a4,4,0,0,1-1.61.49,3.81,3.81,0,0,1-.59,0h0v-8h0a5.26,5.26,0,0,0,.89-.07,3.91,3.91,0,0,0,1.31-.45l143.17-82.65C400,357,400.05,356,399.1,355.31Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1,355.31a4.92,4.92,0,0,1,1.94,3.63v2.9a4.87,4.87,0,0,1-2.2,3.81L255.68,448.29a4,4,0,0,1-1.61.49,3.81,3.81,0,0,1-.59,0h0v-8h0a5.26,5.26,0,0,0,.89-.07,3.91,3.91,0,0,0,1.31-.45l143.17-82.65C400,357,400.05,356,399.1,355.31Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.64,313.86a3,3,0,0,1,3.16.35l83.33,48.1a1.14,1.14,0,0,1,0,2.17L267.28,430.2a4.15,4.15,0,0,1-3.76,0l-83.34-48.1a1.14,1.14,0,0,1,0-2.17Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.64,313.86a3,3,0,0,1,3.16.35l83.33,48.1a1.14,1.14,0,0,1,0,2.17L267.28,430.2a4.15,4.15,0,0,1-3.76,0l-83.34-48.1a1.14,1.14,0,0,1,0-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.18,386.72c-.91.71-.81,1.71.29,2.34l88.81,51.27a4.47,4.47,0,0,0,2.2.52v8a4.44,4.44,0,0,1-2.19-.53L162.47,397a4.82,4.82,0,0,1-2.19-3.8v-2.9A5,5,0,0,1,162.18,386.72Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.18,386.72c-.91.71-.81,1.71.29,2.34l88.81,51.27a4.47,4.47,0,0,0,2.2.52v8a4.44,4.44,0,0,1-2.19-.53L162.47,397a4.82,4.82,0,0,1-2.19-3.8v-2.9A5,5,0,0,1,162.18,386.72Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.63,333.13a1.48,1.48,0,0,0,1.33,0c.37-.21.37-.55,0-.77a1.48,1.48,0,0,0-1.33,0C348.26,332.58,348.26,332.92,348.63,333.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,339.17a3,3,0,0,0,2.66,0,.82.82,0,0,0,0-1.54,3,3,0,0,0-2.66,0C350,338.05,350,338.74,350.76,339.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.88,336.49c.49-.28.46-.75-.06-1.06l-8.76-5.05a2,2,0,0,0-1.83,0c-.49.28-.46.75.06,1l8.76,5.06A2,2,0,0,0,348.88,336.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.47 342.96 331.13 387.8 300.06 405.73 222.41 360.9 253.47 342.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63,329c-2.15,1.24-2.15,3.25,0,4.48a8.56,8.56,0,0,0,7.76,0c2.15-1.23,2.15-3.24,0-4.48A8.56,8.56,0,0,0,280.63,329Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.39,331.11a.69.69,0,0,0,0,1.31,2.5,2.5,0,0,0,2.26,0,.69.69,0,0,0,0-1.31A2.5,2.5,0,0,0,285.39,331.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.39,339.82a.13.13,0,0,1,.07.14.27.27,0,0,1-.15.17l-.79.45a.62.62,0,0,1-.28.09.55.55,0,0,1-.24,0l-3.67-2.12a.12.12,0,0,1-.07-.14.32.32,0,0,1,.15-.16l7.2-4.16a.51.51,0,0,1,.28-.08.39.39,0,0,1,.25,0l.67.39a.12.12,0,0,1,.08.14.32.32,0,0,1-.15.16l-6.11,3.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.77,338.87a1.72,1.72,0,0,1,.65.59.94.94,0,0,1,.11.67,1.55,1.55,0,0,1-.34.71,3.44,3.44,0,0,1-.77.66l-.25.15-.31.18-.31.18-.26.14a6.36,6.36,0,0,1-1.15.44,5.57,5.57,0,0,1-1.2.2,5,5,0,0,1-1.17-.07,3.45,3.45,0,0,1-1-.37,1.76,1.76,0,0,1-.64-.59,1.07,1.07,0,0,1-.13-.67,1.49,1.49,0,0,1,.35-.7,3.74,3.74,0,0,1,.77-.67l.23-.15.31-.18a3.07,3.07,0,0,1,.31-.17l.27-.15a6.09,6.09,0,0,1,1.15-.44,5.66,5.66,0,0,1,1.21-.2,5,5,0,0,1,1.17.07A3,3,0,0,1,301.77,338.87Zm-1.49,2a1.66,1.66,0,0,0,.45-.4.51.51,0,0,0,.12-.35.39.39,0,0,0-.12-.28,1.73,1.73,0,0,0-.29-.23,3,3,0,0,0-.4-.17,1.81,1.81,0,0,0-.49-.07,2.58,2.58,0,0,0-.6.07,3.37,3.37,0,0,0-.7.26l-.23.13-.29.15-.28.17-.2.13a1.68,1.68,0,0,0-.45.41.58.58,0,0,0-.13.34.48.48,0,0,0,.13.29,1.11,1.11,0,0,0,.29.22,1.71,1.71,0,0,0,.39.17,1.87,1.87,0,0,0,.5.08,2.26,2.26,0,0,0,.6-.08,3,3,0,0,0,.69-.26,1.29,1.29,0,0,0,.23-.12l.28-.16.28-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.42,342.65a1.69,1.69,0,0,0-1-.25,2.93,2.93,0,0,0-1.19.43l-2.9,1.67a.62.62,0,0,1-.28.09.43.43,0,0,1-.24,0l-.64-.37a.13.13,0,0,1-.07-.14.26.26,0,0,1,.15-.16l5.19-3a.66.66,0,0,1,.28-.09.47.47,0,0,1,.25,0l.63.37a.1.1,0,0,1,.07.14.24.24,0,0,1-.14.16l-.26.15a4.14,4.14,0,0,1,.88,0,2.38,2.38,0,0,1,.79.29l.38.22a.12.12,0,0,1,.07.14.29.29,0,0,1-.15.16l-.73.43a.69.69,0,0,1-.28.08.38.38,0,0,1-.25,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,344.23a7.86,7.86,0,0,1,1.32-.6,6.41,6.41,0,0,1,1.37-.31,4.64,4.64,0,0,1,1.29,0,3,3,0,0,1,1.08.35,1.34,1.34,0,0,1,.62.63,1,1,0,0,1,0,.73,2,2,0,0,1-.49.76,4.53,4.53,0,0,1-.94.71l-.5.29a.83.83,0,0,1-.28.08.38.38,0,0,1-.25,0l-2.79-1.61a1.2,1.2,0,0,0-.37.3.53.53,0,0,0-.12.32.48.48,0,0,0,.11.29,1,1,0,0,0,.29.25,2.12,2.12,0,0,0,.51.21,2.49,2.49,0,0,0,.46.05l.27,0a.49.49,0,0,1,.19.07l.67.39a.13.13,0,0,1,.08.14.29.29,0,0,1-.15.16,2.12,2.12,0,0,1-.53.16,4.41,4.41,0,0,1-.85.06,5.1,5.1,0,0,1-1-.11,3.33,3.33,0,0,1-1-.38,1.49,1.49,0,0,1-.63-.61,1,1,0,0,1,0-.74A2,2,0,0,1,304,345,5.4,5.4,0,0,1,305,344.23Zm3.73.22a1.52,1.52,0,0,0-.51-.19,2,2,0,0,0-.54,0,2.09,2.09,0,0,0-.51.09,2.66,2.66,0,0,0-.43.15l1.89,1.09.29-.23a.74.74,0,0,0,.18-.28.43.43,0,0,0,0-.31A.86.86,0,0,0,308.76,344.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.48,346.4a3.57,3.57,0,0,1,1,0,2.05,2.05,0,0,1,.77.24,1.1,1.1,0,0,1,.6.65.93.93,0,0,1-.16.7,3.72,3.72,0,0,1,.67-.08,4.52,4.52,0,0,1,.64,0,3,3,0,0,1,.55.11,2,2,0,0,1,.44.18,1.23,1.23,0,0,1,.58.58.78.78,0,0,1-.05.63,2.12,2.12,0,0,1-.56.64,6.85,6.85,0,0,1-.91.62l-3,1.73a.57.57,0,0,1-.28.08.38.38,0,0,1-.25,0l-.64-.36a.14.14,0,0,1-.07-.15.32.32,0,0,1,.15-.16l2.94-1.7c.51-.29.79-.53.84-.73s0-.38-.31-.53a1.51,1.51,0,0,0-.86-.16,3.05,3.05,0,0,0-1.27.44l-3,1.73a.77.77,0,0,1-.28.08.36.36,0,0,1-.24,0l-.64-.37a.12.12,0,0,1-.07-.14.28.28,0,0,1,.15-.16l2.94-1.7c.51-.29.79-.54.84-.74s-.05-.37-.31-.52a1.52,1.52,0,0,0-.89-.16,3.14,3.14,0,0,0-1.3.46l-2.94,1.7a.62.62,0,0,1-.28.09.49.49,0,0,1-.25,0l-.63-.37a.11.11,0,0,1-.07-.14.24.24,0,0,1,.14-.16l5.2-3a.62.62,0,0,1,.28-.09.49.49,0,0,1,.25,0l.63.37c.06,0,.09.08.07.14a.24.24,0,0,1-.14.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.09,351.83c-.64.35-1.26.71-1.88,1.08-.82.51-1.28.95-1.36,1.34s.13.73.64,1a3.93,3.93,0,0,0,.7.31,3.18,3.18,0,0,0,.78.12,4.18,4.18,0,0,0,.89-.1,6.49,6.49,0,0,0,1.07-.34.56.56,0,0,1,.25-.07.33.33,0,0,1,.17,0l.16.1a.1.1,0,0,1,.07.11s0,.08-.11.12a6.31,6.31,0,0,1-1,.39,5,5,0,0,1-1.17.22,5.49,5.49,0,0,1-1.27-.06,3.64,3.64,0,0,1-1.24-.45,1.77,1.77,0,0,1-.75-.7,1,1,0,0,1-.05-.76,2,2,0,0,1,.55-.78,6,6,0,0,1,1.06-.79l1-.57c.35-.21.69-.39,1-.57a8.6,8.6,0,0,1,1.36-.61,6.23,6.23,0,0,1,1.36-.32,4.85,4.85,0,0,1,1.32,0,3.53,3.53,0,0,1,1.2.43,1.94,1.94,0,0,1,.79.72,1.05,1.05,0,0,1,.1.73,1.39,1.39,0,0,1-.38.67,3.69,3.69,0,0,1-.68.56.4.4,0,0,1-.21.07.36.36,0,0,1-.19,0l-.17-.1a.12.12,0,0,1-.07-.09s0-.09.12-.15a2.81,2.81,0,0,0,.6-.61.87.87,0,0,0,.16-.52.72.72,0,0,0-.21-.45,2.15,2.15,0,0,0-.53-.4,3,3,0,0,0-1.78-.37A5.78,5.78,0,0,0,322.09,351.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.85,355.08a1.51,1.51,0,0,1,.6.57.84.84,0,0,1,0,.64,1.59,1.59,0,0,1-.46.67,4.73,4.73,0,0,1-.86.66l-.21.13-.25.15-.27.15-.21.11a7.17,7.17,0,0,1-1.14.5,5.55,5.55,0,0,1-1.16.27,4.56,4.56,0,0,1-1.11,0,3,3,0,0,1-1-.35,1.44,1.44,0,0,1-.6-.57.79.79,0,0,1,0-.64,1.65,1.65,0,0,1,.45-.67,4.5,4.5,0,0,1,.87-.66l.2-.12.26-.16.26-.14.21-.12a7.17,7.17,0,0,1,1.14-.5,5.15,5.15,0,0,1,1.17-.26,3.68,3.68,0,0,1,1.1,0A2.77,2.77,0,0,1,329.85,355.08Zm-1.25,2.28c.62-.38,1-.73,1.06-1.07s-.06-.61-.45-.83a2.4,2.4,0,0,0-1.45-.27,6.86,6.86,0,0,0-2.27.85l-.41.24c-.62.38-1,.74-1.06,1.07s.07.61.46.84a2.46,2.46,0,0,0,1.45.26,4.73,4.73,0,0,0,1.85-.61l.42-.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.63,357.55a4.11,4.11,0,0,1,1,0,2.23,2.23,0,0,1,.9.3,1,1,0,0,1,.54.62.92.92,0,0,1-.25.75,4,4,0,0,1,1.33-.11,2.54,2.54,0,0,1,1.14.33,1.11,1.11,0,0,1,.46.45.7.7,0,0,1,0,.55,1.62,1.62,0,0,1-.42.62,4.58,4.58,0,0,1-.94.68l-3.24,1.87a.4.4,0,0,1-.43,0l-.14-.09q-.18-.11.06-.24l3.13-1.81a3.9,3.9,0,0,0,.82-.58,1.09,1.09,0,0,0,.33-.48.45.45,0,0,0-.06-.39,1.12,1.12,0,0,0-.34-.3,1.79,1.79,0,0,0-.48-.17,2.38,2.38,0,0,0-.67,0,3.74,3.74,0,0,0-.84.18,5.55,5.55,0,0,0-1,.47L330.47,362a.42.42,0,0,1-.43,0l-.14-.08c-.12-.07-.1-.15.06-.25l3.13-1.8a3.86,3.86,0,0,0,.81-.59,1.17,1.17,0,0,0,.32-.48.47.47,0,0,0-.05-.39,1,1,0,0,0-.33-.29,1.79,1.79,0,0,0-.48-.17,2.32,2.32,0,0,0-.66,0,3.53,3.53,0,0,0-.84.18,4.86,4.86,0,0,0-1,.46l-3.14,1.82a.42.42,0,0,1-.43,0l-.14-.08c-.12-.07-.1-.15.06-.25l5.31-3.06a.4.4,0,0,1,.43,0l.14.08c.12.07.1.16-.06.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,365.65a1.19,1.19,0,0,1-.61-.65,1,1,0,0,1,.08-.67l-2.64,1.52a.4.4,0,0,1-.43,0l-.14-.08c-.12-.08-.1-.16.06-.25l7.43-4.29a.4.4,0,0,1,.43,0l.14.08c.12.07.1.15-.06.25l-.53.3a4.69,4.69,0,0,1,1.18-.05,2.63,2.63,0,0,1,1.11.35,1.21,1.21,0,0,1,.59.61.81.81,0,0,1-.05.66,2.15,2.15,0,0,1-.54.67,7.17,7.17,0,0,1-.85.62l-.36.22-.38.2a8.9,8.9,0,0,1-1.08.5,5.94,5.94,0,0,1-1.15.31,4.44,4.44,0,0,1-1.15,0A2.71,2.71,0,0,1,336.11,365.65Zm2-2.78-.45.24a4.82,4.82,0,0,0-.42.26,3.36,3.36,0,0,0-.59.44,1.31,1.31,0,0,0-.36.49.67.67,0,0,0,0,.5.83.83,0,0,0,.42.44,1.89,1.89,0,0,0,.79.26,3.06,3.06,0,0,0,.85,0,4.15,4.15,0,0,0,.88-.25,6.79,6.79,0,0,0,.87-.39l.62-.36a5.45,5.45,0,0,0,.68-.5,1.88,1.88,0,0,0,.43-.5.68.68,0,0,0,.05-.5.86.86,0,0,0-.44-.46,1.92,1.92,0,0,0-.79-.24,3.63,3.63,0,0,0-.87,0,4.29,4.29,0,0,0-.87.23A4.69,4.69,0,0,0,338.12,362.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,368.91q-.18-.11.06-.24l.53-.31a3.92,3.92,0,0,1-.51.07,3.77,3.77,0,0,1-.58,0,3.56,3.56,0,0,1-.62-.12,3.11,3.11,0,0,1-.66-.28,1.25,1.25,0,0,1-.44-.41.76.76,0,0,1-.13-.48,1.06,1.06,0,0,1,.2-.49,1.79,1.79,0,0,1,.54-.45,3.26,3.26,0,0,1,.8-.32,3.58,3.58,0,0,1,.87-.11,4.46,4.46,0,0,1,1.79.35l1.57.62.39-.23q.6-.35.66-.69c0-.24-.13-.47-.53-.7a2,2,0,0,0-1-.28,2.57,2.57,0,0,0-.84.12,1.22,1.22,0,0,1-.27.06.33.33,0,0,1-.17,0l-.11-.07a.11.11,0,0,1-.06-.12s.05-.09.12-.13a2.1,2.1,0,0,1,.47-.18,4.16,4.16,0,0,1,1.6-.05,2.62,2.62,0,0,1,.87.32,1.59,1.59,0,0,1,.64.57.69.69,0,0,1,0,.56,1.26,1.26,0,0,1-.38.51,3.53,3.53,0,0,1-.61.44L342.56,369a.4.4,0,0,1-.43,0Zm-1.05-1.22a2.21,2.21,0,0,0,.67.24,3.21,3.21,0,0,0,.83,0,5,5,0,0,0,.95-.2,5.81,5.81,0,0,0,1-.47l.37-.22-1.27-.5a3,3,0,0,0-2.58-.12,1,1,0,0,0-.38.33.52.52,0,0,0-.09.33.56.56,0,0,0,.15.31A1.35,1.35,0,0,0,340.94,367.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,371.81a.4.4,0,0,1-.43,0l-.14-.08c-.12-.07-.1-.16.06-.25l3.11-1.8a2.29,2.29,0,0,0,1.08-1c.12-.32,0-.61-.45-.85a2.38,2.38,0,0,0-1.46-.26,4.28,4.28,0,0,0-1.77.6l-3.11,1.8a.42.42,0,0,1-.43,0l-.14-.08c-.12-.07-.1-.15.06-.25l5.31-3.06a.4.4,0,0,1,.43,0l.14.09q.18.1-.06.24l-.52.31a4.69,4.69,0,0,1,1.17-.06,2.59,2.59,0,0,1,1.11.36,1.22,1.22,0,0,1,.56.54.8.8,0,0,1,0,.61,1.72,1.72,0,0,1-.47.64,4.66,4.66,0,0,1-.88.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,374.4a.57.57,0,0,1-.18,0,.29.29,0,0,1-.18-.05l-.17-.09a.1.1,0,0,1-.05-.11.24.24,0,0,1,.11-.12l.27-.1,2.65-.78,3.42-3.82a.71.71,0,0,1,.18-.16.59.59,0,0,1,.2-.06.29.29,0,0,1,.19,0l.17.1c.06,0,.08.07.08.1a.54.54,0,0,1,0,.11l-3,3.36,5.85-1.72.18,0a.37.37,0,0,1,.18,0l.17.1a.1.1,0,0,1,0,.11.19.19,0,0,1-.11.11,1,1,0,0,1-.27.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.13,362.31l-83.33-48.1a3,3,0,0,0-3.16-.35l-11.44,6.6,87.08,50.29,10.85-6.27A1.14,1.14,0,0,0,381.13,362.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.42,318.18l.59-.33a.45.45,0,0,1,.4,0l0,0c.1.05.07.16-.06.23l-.58.34a.46.46,0,0,1-.41,0l0,0C296.27,318.36,296.3,318.26,296.42,318.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,318.64l1-.59a.44.44,0,0,1,.4,0l.05,0c.1.05.07.15-.06.23l-1,.58a.45.45,0,0,1-.4,0l-.05,0C297.06,318.81,297.08,318.71,297.21,318.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,319.09l1.44-.83a.46.46,0,0,1,.41,0l0,0c.1.06.07.16-.05.23l-1.44.84a.5.5,0,0,1-.41,0l0,0C297.84,319.27,297.87,319.16,298,319.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,319.54l2.48-1.43a.47.47,0,0,1,.41,0l0,0c.1.06.07.16,0,.23l-2.49,1.44a.44.44,0,0,1-.4,0l0,0C298.63,319.72,298.65,319.62,298.78,319.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.73,320.87s0,0,.06-.07l.37-.21-.88-.5s0-.06,0-.09l.13-.08.08,0,.09,0,2.24-.21a.14.14,0,0,1,.09,0l.08,0,.12.07s.05.05.05.07,0,0-.06.06l-1.28.74.2.11s.05,0,.05.06l-.07.07-.09.05a.18.18,0,0,1-.2,0l-.2-.11-.36.21-.11,0-.11,0-.15-.08S300.73,320.89,300.73,320.87Zm.79-.42.91-.53-1.54.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,321.34c0-.21.22-.42.58-.63a2.31,2.31,0,0,1,1.1-.34,1.94,1.94,0,0,1,1,.25,1.48,1.48,0,0,1,.3.23.56.56,0,0,1,.15.23s0,0,0,0h-.05l-.24.05h-.06l0,0a.74.74,0,0,0-.33-.33,1.3,1.3,0,0,0-.7-.17,1.78,1.78,0,0,0-.81.26c-.28.16-.43.32-.45.46s.07.28.27.4a1.75,1.75,0,0,0,.24.11l.23.06.59-.34-.36-.21s-.06,0-.05-.06,0,0,.06-.06l.09,0a.26.26,0,0,1,.1,0l.11,0,.58.34s.06.05.05.07,0,.05-.07.08l-.85.49-.08,0h-.08a2.2,2.2,0,0,1-.88-.3C302.12,321.75,302,321.55,302,321.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,361.61a.26.26,0,0,0-.15-.31l-2.63-1.52a1,1,0,0,0-.94.07l-1.28.74a.59.59,0,0,0-.31.36.22.22,0,0,0,0,.16.31.31,0,0,0,.14.16l2.63,1.52a1.09,1.09,0,0,0,.95-.08l1.28-.74A.62.62,0,0,0,375.9,361.61Zm-5.09-.68a.27.27,0,0,1,.15-.15l1.28-.74A.81.81,0,0,1,373,360l2.63,1.52a.15.15,0,0,1,.08.08,0,0,0,0,1,0,.05.28.28,0,0,1-.15.16l-1.28.73a.81.81,0,0,1-.72.06l-2.63-1.52A.12.12,0,0,1,370.81,360.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,360.93l-1.51.87-1.42-.82,0,0,.05,0,1.15-.66a.62.62,0,0,1,.54-.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.71,362.05c.1.06,0,.23-.3.38l-.24.13c-.26.16-.56.24-.66.18l-.19-.09,1.21-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,324.14a1.14,1.14,0,0,1-1,0,.31.31,0,0,1,0-.59,1.14,1.14,0,0,1,1,0A.31.31,0,0,1,307.21,324.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,323.07a2.91,2.91,0,0,0-1.9-.27c-.14,0-.22.09-.2.17h0c0,.1.19.17.36.14a2.06,2.06,0,0,1,1.33.19c.37.21.48.51.34.77-.06.1.06.2.23.21h0a.34.34,0,0,0,.31-.11C308.72,323.79,308.56,323.37,308.05,323.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.86,322.6a4.72,4.72,0,0,0-2.82-.48c-.15,0-.25.1-.23.18h0c0,.09.18.16.35.13a3.84,3.84,0,0,1,2.3.39c.63.36.85.87.67,1.33,0,.1.07.19.24.2h0a.31.31,0,0,0,.31-.13C309.9,323.66,309.63,323,308.86,322.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7,340.41l-.09,0-.09,0-.13-.08a.06.06,0,0,1,0-.1l1.75-1-.9-.07-.09,0a.06.06,0,0,1,0-.05l0-.1s0,0,.05-.05a.13.13,0,0,1,.09,0l1.2.09h.07l.05,0,.13.08s0,0,0,0a.07.07,0,0,1,0,.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,340l0,0a.07.07,0,0,1,0,.05l-.21.13-.09,0-.08,0-.22-.13a.05.05,0,0,1,0,0,.05.05,0,0,1,0-.05l.22-.13.08,0,.09,0Zm-1.11.64,0,0a.07.07,0,0,1,0,.05l-.21.13-.09,0-.08,0-.22-.13a.05.05,0,0,1,0,0,.05.05,0,0,1,0-.05l.21-.13.08,0,.09,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.92,341.79s0,0,0-.05a.05.05,0,0,1,0-.05l.43-.25-1-.58a.07.07,0,0,1,0-.05s0,0,0-.05l.11-.06.07,0h.09l2.31-.18h.11l.09,0,.12.07s0,0,0,.05a.05.05,0,0,1,0,.05l-1.32.76.27.16s0,0,0,0a.05.05,0,0,1,0,.05l-.11.07-.09,0-.08,0-.27-.16-.44.25a.13.13,0,0,1-.09,0,.11.11,0,0,1-.08,0Zm.72-.52.89-.51-1.58.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.55,342.11a.41.41,0,0,0-.05.09.11.11,0,0,0,0,.1.24.24,0,0,0,.09.12.89.89,0,0,0,.22.16.72.72,0,0,0,.2.09,1,1,0,0,0,.24.05.81.81,0,0,0,.22,0,.53.53,0,0,0,.22-.08.35.35,0,0,0,.14-.12.15.15,0,0,0,0-.13.31.31,0,0,0-.09-.12l-.17-.13-.27-.15a.05.05,0,0,1,0-.05s0,0,0-.05l.12-.06.07,0h.07l1.19,0-.92-.53a.06.06,0,0,1,0-.1l.12-.06a.11.11,0,0,1,.08,0s.07,0,.09,0l1.25.72a.05.05,0,0,1,0,.05.05.05,0,0,1,0,0l-.12.07-.07,0h-.09l-1.17,0a.69.69,0,0,1,.24.19.41.41,0,0,1,.1.21.27.27,0,0,1-.06.2.71.71,0,0,1-.22.18,1,1,0,0,1-.35.13,1.2,1.2,0,0,1-.38,0,1.78,1.78,0,0,1-.39-.07,1.54,1.54,0,0,1-.35-.15,1.26,1.26,0,0,1-.32-.24.4.4,0,0,1-.12-.22.31.31,0,0,1,0-.19.53.53,0,0,1,.15-.15h.14l.15.09a.05.05,0,0,1,0,0S338.57,342.1,338.55,342.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,321.74l69.64,40.2c1.14.66,1.2,1.71.13,2.35a4.4,4.4,0,0,1-4-.05L294.37,324c-1.14-.66-1.2-1.7-.13-2.32A4.46,4.46,0,0,1,298.25,321.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,354.21l-7.51,4.34a1.26,1.26,0,0,0,0,2.39l7.51,4.33a4.58,4.58,0,0,0,4.14,0l7.51-4.33a1.26,1.26,0,0,0,0-2.39L304,354.21A4.58,4.58,0,0,0,299.9,354.21Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,362.59l1.11-.65c.07,0,.07-.1,0-.15l-.88-.64a.11.11,0,0,1,0-.18,2.59,2.59,0,0,0,.32-.44.29.29,0,0,1,.2-.13l1.49-.09a.15.15,0,0,0,.13-.15v-.83a.14.14,0,0,0-.13-.15l-1.49-.09a.27.27,0,0,1-.2-.14,2.59,2.59,0,0,0-.32-.44.11.11,0,0,1,0-.18l.88-.64a.08.08,0,0,0,0-.15l-1.11-.64a.31.31,0,0,0-.25,0l-1.13.52a.46.46,0,0,1-.26,0,6.27,6.27,0,0,0-.88-.21.19.19,0,0,1-.16-.16l-.15-.75a.16.16,0,0,0-.16-.13h-1.64a.18.18,0,0,0-.17.13l-.14.75a.2.2,0,0,1-.16.16,6,6,0,0,0-.88.21.46.46,0,0,1-.26,0l-1.13-.52a.31.31,0,0,0-.25,0l-1.12.64a.09.09,0,0,0,0,.15l.89.64a.12.12,0,0,1,0,.18,2.14,2.14,0,0,0-.32.44.29.29,0,0,1-.2.14l-1.49.09a.15.15,0,0,0-.14.15v.83a.15.15,0,0,0,.14.15l1.49.09a.31.31,0,0,1,.2.13,2.14,2.14,0,0,0,.32.44.12.12,0,0,1,0,.18l-.89.64a.09.09,0,0,0,0,.15l1.12.65a.31.31,0,0,0,.25,0l1.13-.53a.46.46,0,0,1,.26,0,6,6,0,0,0,.88.21.2.2,0,0,1,.16.16l.14.74a.18.18,0,0,0,.17.14h1.64a.16.16,0,0,0,.16-.14l.15-.74a.19.19,0,0,1,.16-.16,6.27,6.27,0,0,0,.88-.21.46.46,0,0,1,.26,0l1.13.53A.31.31,0,0,0,305.78,362.59Zm-5.7-1.76a1.15,1.15,0,0,1,0-2.18,4.17,4.17,0,0,1,3.77,0c1,.61,1,1.58,0,2.18A4.17,4.17,0,0,1,300.08,360.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,343,273,347.35a1.26,1.26,0,0,0,0,2.39l7.51,4.34a4.58,4.58,0,0,0,4.14,0l7.51-4.34a1.26,1.26,0,0,0,0-2.39L284.6,343A4.58,4.58,0,0,0,280.46,343Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.21 349.31 280.25 348.75 277.89 350.12 276.11 349.09 279.92 346.89 278.87 346.29 286.46 346.28 286.44 350.66 285.39 350.06 281.58 352.25 279.81 351.23 282.17 349.86 281.21 349.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,365.43l-7.51,4.33a1.26,1.26,0,0,0,0,2.39l7.51,4.34a4.58,4.58,0,0,0,4.14,0l7.51-4.34a1.26,1.26,0,0,0,0-2.39l-7.51-4.33A4.58,4.58,0,0,0,319.3,365.43Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.25,372.05a.24.24,0,0,0-.11-.15l-7.88-4.54a.59.59,0,0,0-.35-.06l.76,4.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,367.3a.65.65,0,0,0-.24.06L314,370.61a.23.23,0,0,0-.12.16l6.06.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.25,372.05l-6.42,0,.35,3.52-.78-3.52h-1a.47.47,0,0,1-.47-.47v-.2l-6.06-.64a.21.21,0,0,0,.12.19l7.88,4.56a.72.72,0,0,0,.61,0l5.65-3.27A.18.18,0,0,0,328.25,372.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.9 367.29 319.9 367.3 319.91 367.3 319.9 367.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.27 372.05 328.25 372.05 328.25 372.05 328.27 372.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.44 360.3 252.33 348.24 283.67 366.33 262.78 378.4 231.44 360.3",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.44 360.3 252.33 348.24 283.67 366.33 262.78 378.4 231.44 360.3",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.68,364.59a1.16,1.16,0,0,0,0,2.19,4.19,4.19,0,0,0,3.78,0,1.16,1.16,0,0,0,0-2.19A4.19,4.19,0,0,0,268.68,364.59Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.44 360.3 239.27 355.78 255.1 357.75 255.25 370.68 256.13 365.8 264.52 367.24 264.96 377.14 262.78 378.4 231.44 360.3",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,370.15l20.72,12c.77.44.81,1.14.09,1.56a3,3,0,0,1-2.7-.05l-20.72-12c-.77-.44-.81-1.14-.09-1.56A3,3,0,0,1,290.29,370.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.51,372.85l31.17,18c.46.27.54.65.18.86a1.69,1.69,0,0,1-1.49-.1l-31.17-18c-.46-.26-.54-.65-.18-.86A1.66,1.66,0,0,1,284.51,372.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,374.36l31.16,18c.46.27.55.65.19.86a1.69,1.69,0,0,1-1.49-.1l-31.17-18c-.46-.27-.54-.65-.18-.86A1.66,1.66,0,0,1,281.9,374.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,375.86l31.17,18c.46.27.55.65.18.86a1.64,1.64,0,0,1-1.48-.11l-31.17-18c-.46-.27-.54-.65-.18-.86A1.67,1.67,0,0,1,279.28,375.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.67,377.37,287,383.3c.47.26.55.65.19.86a1.66,1.66,0,0,1-1.49-.11l-10.28-5.92c-.46-.27-.55-.66-.18-.86A1.67,1.67,0,0,1,276.67,377.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.39,380.61l1.14-.65a3,3,0,0,1,2.78,0l7.67,4.42a.85.85,0,0,1,0,1.61l-1.14.65a3,3,0,0,1-2.78,0l-7.67-4.42A.85.85,0,0,1,269.39,380.61Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,393.47a.8.8,0,0,1,0,1.51,2.86,2.86,0,0,1-2.61,0,.8.8,0,0,1,0-1.51A2.92,2.92,0,0,1,294.34,393.47Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,395.92h0a2.16,2.16,0,0,1,1.06.25c.21.12.29.25.29.32s-.08.19-.29.32a2.27,2.27,0,0,1-1.06.24,2.12,2.12,0,0,1-1.05-.24c-.22-.12-.3-.25-.3-.32s.08-.2.3-.32a2.12,2.12,0,0,1,1.05-.25m0-.5a2.74,2.74,0,0,0-1.3.31c-.73.42-.73,1.1,0,1.51a2.63,2.63,0,0,0,1.3.31,2.67,2.67,0,0,0,1.31-.31.8.8,0,0,0,0-1.51,2.78,2.78,0,0,0-1.31-.31Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,398.18h0a2.12,2.12,0,0,1,1.05.25c.22.12.3.25.3.32s-.08.2-.3.32a2.12,2.12,0,0,1-1.05.25,2.16,2.16,0,0,1-1.06-.25c-.21-.12-.29-.25-.29-.32s.08-.2.29-.32a2.16,2.16,0,0,1,1.06-.25m0-.5a2.67,2.67,0,0,0-1.31.32.79.79,0,0,0,0,1.5,2.67,2.67,0,0,0,1.31.32,2.64,2.64,0,0,0,1.3-.32.79.79,0,0,0,0-1.5,2.64,2.64,0,0,0-1.3-.32Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.76,363.85l75.18,43.41c.69.39.69,1,0,1.43l-5.28,3.05a2.73,2.73,0,0,1-2.49,0L212,368.34a.76.76,0,0,1,0-1.44l5.28-3A2.77,2.77,0,0,1,219.76,363.85Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.76,363.85l75.18,43.41c.69.39.69,1,0,1.43l-5.28,3.05a2.73,2.73,0,0,1-2.49,0L212,368.34a.76.76,0,0,1,0-1.44l5.28-3A2.77,2.77,0,0,1,219.76,363.85Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.09,409.32c-1-.56-.7-1.61.58-2.35a4.56,4.56,0,0,1,4.07-.34c1,.56.7,1.61-.58,2.35A4.63,4.63,0,0,1,286.09,409.32Zm4.2-2.43a3.69,3.69,0,0,0-3.28.27c-1,.6-1.25,1.45-.47,1.9a3.75,3.75,0,0,0,3.29-.27C290.86,408.19,291.07,407.34,290.29,406.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,408.55l-1.73-1c-.1-.05-.07-.15.05-.23a.48.48,0,0,1,.4,0l1.73,1c.09.06.07.16-.06.23A.42.42,0,0,1,289,408.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.21,408.63a.09.09,0,0,1,0-.12.41.41,0,0,1,.35-.17l1.51,0,0-.87c0-.09.13-.18.29-.2s.27,0,.27.11l0,1.08a.2.2,0,0,1-.11.14.65.65,0,0,1-.24.06l-1.86,0A.33.33,0,0,1,287.21,408.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,366.53a1.15,1.15,0,0,0,0,2.18,4.16,4.16,0,0,0,3.78,0,1.15,1.15,0,0,0,0-2.18A4.19,4.19,0,0,0,216.63,366.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,370l52.69,30.42c.78.45.92,1.1.31,1.45a2.81,2.81,0,0,1-2.52-.17L222.7,371.29c-.78-.45-.91-1.1-.3-1.46A2.82,2.82,0,0,1,224.91,370Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,370.58,283.29,414a.76.76,0,0,1,0,1.44L278,418.47a2.77,2.77,0,0,1-2.48,0l-75.18-43.41c-.69-.39-.69-1,0-1.43l5.28-3.05A2.73,2.73,0,0,1,208.12,370.58Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.44,416c-1-.55-.7-1.61.58-2.35a4.59,4.59,0,0,1,4.07-.33c1,.55.71,1.61-.58,2.35A4.59,4.59,0,0,1,274.44,416Zm4.21-2.43a3.75,3.75,0,0,0-3.29.28c-1,.59-1.25,1.45-.47,1.89a3.72,3.72,0,0,0,3.29-.27C279.21,414.91,279.42,414.06,278.65,413.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.32,415.28l-1.73-1c-.09-.06-.07-.16.05-.23a.44.44,0,0,1,.4,0l1.73,1c.1.05.07.16,0,.23A.48.48,0,0,1,277.32,415.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,415.36a.1.1,0,0,1-.05-.13.42.42,0,0,1,.35-.16l1.51,0,0-.88c0-.08.13-.17.29-.19s.28,0,.27.11l0,1.07s0,.1-.11.14a.67.67,0,0,1-.24.07l-1.86,0A.33.33,0,0,1,275.56,415.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,373.25a1.16,1.16,0,0,0,0,2.19,4.19,4.19,0,0,0,3.78,0,1.15,1.15,0,0,0,0-2.18A4.16,4.16,0,0,0,205,373.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3,376.76,266,407.18c.78.45.92,1.1.31,1.45a2.82,2.82,0,0,1-2.51-.18L211.09,378c-.78-.45-.92-1.1-.31-1.45A2.84,2.84,0,0,1,213.3,376.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,377.31l75.18,43.4a.76.76,0,0,1,0,1.43l-5.29,3.05a2.71,2.71,0,0,1-2.48,0l-75.18-43.4a.76.76,0,0,1,0-1.44l5.29-3A2.71,2.71,0,0,1,196.47,377.31Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,377.31l75.18,43.4a.76.76,0,0,1,0,1.43l-5.29,3.05a2.71,2.71,0,0,1-2.48,0l-75.18-43.4a.76.76,0,0,1,0-1.44l5.29-3A2.71,2.71,0,0,1,196.47,377.31Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79,422.77c-1-.56-.7-1.61.58-2.35a4.62,4.62,0,0,1,4.08-.34c1,.56.7,1.61-.58,2.35A4.65,4.65,0,0,1,262.79,422.77Zm4.21-2.43a3.72,3.72,0,0,0-3.29.27c-1,.6-1.25,1.45-.47,1.9a3.72,3.72,0,0,0,3.29-.27C267.56,421.64,267.78,420.79,267,420.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,422l-1.74-1c-.09-.05-.07-.15.06-.22a.43.43,0,0,1,.39,0l1.73,1c.1.05.07.15-.05.22A.42.42,0,0,1,265.68,422Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.91,422.08c-.05,0-.07-.07,0-.12a.39.39,0,0,1,.34-.17l1.51,0,0-.87c0-.09.13-.18.28-.2s.28,0,.28.12l-.05,1.07c0,.05,0,.1-.11.14a.48.48,0,0,1-.24.06l-1.86,0A.24.24,0,0,1,263.91,422.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,380a1.15,1.15,0,0,0,0,2.18,4.13,4.13,0,0,0,3.78,0,1.15,1.15,0,0,0,0-2.18A4.19,4.19,0,0,0,193.34,380Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,383.5l52.69,30.42c.78.45.92,1.1.31,1.46a2.84,2.84,0,0,1-2.52-.18l-52.69-30.42c-.78-.45-.91-1.1-.31-1.46A2.84,2.84,0,0,1,201.68,383.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.9,295.77l-54.21,31.32-.13-.07L124,315.12a11.12,11.12,0,0,1-5-10.94l7.64-39.73,54.21-31.32-7.64,39.73a11.1,11.1,0,0,0,5,10.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.61 264.45 119.03 303.84 173.24 272.55 180.25 236.12 176.83 235.44 126.61 264.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.69,327.09l-20.73-12a11.14,11.14,0,0,1-5-10.93l7.65-39.74-9-5.22-8.74,45.46c-1.15,6,2.24,13.43,7.54,16.49l28.32,16.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.9 295.77 144.69 327.09 144.69 337.53 198.9 306.21 198.9 295.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93,38.33a10.35,10.35,0,0,1,4.52,8.17V212.84a10.66,10.66,0,0,1-4.82,8.35L44.28,340.9a10.3,10.3,0,0,1-9.34.17,10.35,10.35,0,0,1-4.52-8.17V166.56a10.66,10.66,0,0,1,4.82-8.35L242.59,38.5A10.3,10.3,0,0,1,251.93,38.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.71,341.19a10.37,10.37,0,0,1-8.77-.12,10.3,10.3,0,0,1-4.52-8.17V166.56a9.77,9.77,0,0,1,1.42-4.75l9,5.22a9.87,9.87,0,0,0-1.42,4.74V338.12C39.46,341,41.32,342.25,43.71,341.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,212.84V46.5c0-3.07-2.16-4.32-4.82-2.78L44.29,163.43a10.63,10.63,0,0,0-4.82,8.35V338.12c0,3.07,2.16,4.32,4.82,2.78L251.63,221.19A10.66,10.66,0,0,0,256.45,212.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,52.21,47.84,166.6A8.48,8.48,0,0,0,44,173.27V321c0,2.46,1.72,3.46,3.85,2.23l198-114.39a8.54,8.54,0,0,0,3.85-6.67V54.44C249.72,52,248,51,245.86,52.21Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,52.21,47.84,166.6A8.48,8.48,0,0,0,44,173.27V321c0,2.46,1.72,3.46,3.85,2.23l198-114.39a8.54,8.54,0,0,0,3.85-6.67V54.44C249.72,52,248,51,245.86,52.21Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.38,308.59c0,2.54,1.79,3.57,4,2.3l183-105.64a8.82,8.82,0,0,0,4-6.91V75.17l-191,110.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,76.9V198.34a7.85,7.85,0,0,1-3.49,6L54.87,310a2.7,2.7,0,0,1-1.28.42c-1.09,0-1.21-1.3-1.21-1.85V186l189-109.09m1-1.73-191,110.25V308.59c0,1.8.9,2.85,2.21,2.85a3.64,3.64,0,0,0,1.78-.55l183-105.64a8.82,8.82,0,0,0,4-6.91V75.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,177.06a8.83,8.83,0,0,1,4-6.92l183-105.63c2.2-1.28,4-.24,4,2.3v8.36l-191,110.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.86,79.48A4.16,4.16,0,0,0,218,82.73c0,1.19.84,1.68,1.87,1.08a4.13,4.13,0,0,0,1.87-3.24C221.73,79.37,220.9,78.89,219.86,79.48Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.41,75.71A4.15,4.15,0,0,0,224.54,79c0,1.2.84,1.68,1.87,1.09a4.14,4.14,0,0,0,1.88-3.25C228.29,75.6,227.45,75.11,226.41,75.71Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,71.94a4.14,4.14,0,0,0-1.88,3.24c0,1.2.84,1.68,1.88,1.08A4.14,4.14,0,0,0,234.84,73C234.84,71.83,234,71.34,233,71.94Z",
    style: {
      fill: "#046CF1"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75.07,185.13c0,2.47,1.74,3.48,3.88,2.24a8.58,8.58,0,0,0,3.89-6.73c0-2.47-1.74-3.48-3.89-2.24A8.6,8.6,0,0,0,75.07,185.13Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,182.08c0,.72.5,1,1.13.65a2.5,2.5,0,0,0,1.12-2c0-.72-.5-1-1.12-.65A2.49,2.49,0,0,0,79.32,182.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,178.64a.12.12,0,0,1,.16,0,.28.28,0,0,1,.06.2v.92a.71.71,0,0,1-.06.28.48.48,0,0,1-.16.2l-3.67,2.11a.11.11,0,0,1-.15,0,.25.25,0,0,1-.07-.21v-8.31a.62.62,0,0,1,.07-.29.38.38,0,0,1,.15-.19l.68-.39a.12.12,0,0,1,.16,0,.24.24,0,0,1,.07.2v7.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,171.77a1.54,1.54,0,0,1,.83-.26,1,1,0,0,1,.64.23,1.59,1.59,0,0,1,.44.65,2.93,2.93,0,0,1,.18,1,2.36,2.36,0,0,1,0,.29v.71a2.63,2.63,0,0,1,0,.3,5.73,5.73,0,0,1-.19,1.22,5.58,5.58,0,0,1-.43,1.14,4.66,4.66,0,0,1-.64,1,3.4,3.4,0,0,1-.83.7,1.69,1.69,0,0,1-.84.26,1,1,0,0,1-.64-.23,1.39,1.39,0,0,1-.43-.64,3.23,3.23,0,0,1-.19-1c0-.07,0-.17,0-.28v-.72c0-.12,0-.22,0-.3a5.24,5.24,0,0,1,.19-1.22,5.9,5.9,0,0,1,.43-1.15,5.09,5.09,0,0,1,.64-1A3.07,3.07,0,0,1,94.23,171.77Zm1,2.31a1.89,1.89,0,0,0-.12-.59.57.57,0,0,0-.24-.28.47.47,0,0,0-.31,0,1.22,1.22,0,0,0-.34.14,1.67,1.67,0,0,0-.35.26,1.83,1.83,0,0,0-.31.39,3.13,3.13,0,0,0-.24.55,3.81,3.81,0,0,0-.12.74c0,.07,0,.16,0,.26v.65c0,.11,0,.19,0,.25a2,2,0,0,0,.12.59.62.62,0,0,0,.24.28.42.42,0,0,0,.31,0,1.11,1.11,0,0,0,.35-.14,1.74,1.74,0,0,0,.65-.64,3.25,3.25,0,0,0,.24-.56,3.71,3.71,0,0,0,.12-.73c0-.07,0-.15,0-.26v-.65C95.25,174.23,95.24,174.14,95.24,174.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.32,170.5a1.65,1.65,0,0,0-.72.76,2.89,2.89,0,0,0-.23,1.24v3.35a.71.71,0,0,1-.06.28.48.48,0,0,1-.16.2l-.64.36a.12.12,0,0,1-.16,0,.28.28,0,0,1-.06-.2v-6a.75.75,0,0,1,.06-.29.45.45,0,0,1,.16-.19l.64-.37a.13.13,0,0,1,.16,0,.31.31,0,0,1,.06.21v.29a4.29,4.29,0,0,1,.47-.74,2.06,2.06,0,0,1,.65-.54l.37-.22a.13.13,0,0,1,.16,0,.27.27,0,0,1,.07.21v.85a.58.58,0,0,1-.07.28.42.42,0,0,1-.16.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,171.62a7.81,7.81,0,0,1,.14-1.44,6.16,6.16,0,0,1,.41-1.34,4.91,4.91,0,0,1,.65-1.12,2.9,2.9,0,0,1,.85-.76,1.36,1.36,0,0,1,.84-.22,1,1,0,0,1,.65.33,2,2,0,0,1,.42.8,4.69,4.69,0,0,1,.14,1.17v.58a.75.75,0,0,1-.06.29.45.45,0,0,1-.16.19l-2.8,1.61a1.26,1.26,0,0,0,.08.48.58.58,0,0,0,.22.26.46.46,0,0,0,.31.05,1.22,1.22,0,0,0,.36-.13A1.87,1.87,0,0,0,103,172a2.47,2.47,0,0,0,.28-.38,1.33,1.33,0,0,1,.15-.22.42.42,0,0,1,.16-.13l.67-.39a.12.12,0,0,1,.16,0,.22.22,0,0,1,.06.21,1.88,1.88,0,0,1-.13.53,4.33,4.33,0,0,1-.36.77,5.27,5.27,0,0,1-.6.81,3.81,3.81,0,0,1-.82.67,1.5,1.5,0,0,1-.85.23.91.91,0,0,1-.65-.34,2,2,0,0,1-.41-.86A5.65,5.65,0,0,1,100.5,171.62Zm2-3.11a1.43,1.43,0,0,0-.42.35,2.66,2.66,0,0,0-.29.45,4.09,4.09,0,0,0-.18.49,4.3,4.3,0,0,0-.08.45l1.89-1.09a2.2,2.2,0,0,0-.06-.37.61.61,0,0,0-.15-.3.39.39,0,0,0-.27-.13A.82.82,0,0,0,102.55,168.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,165.39a3.86,3.86,0,0,1,.49-.85,2.1,2.1,0,0,1,.59-.54,1.13,1.13,0,0,1,.86-.2,1,1,0,0,1,.53.49,3.76,3.76,0,0,1,.27-.62,4.13,4.13,0,0,1,.34-.54,3.19,3.19,0,0,1,.37-.43,2.91,2.91,0,0,1,.37-.29,1.24,1.24,0,0,1,.8-.21.77.77,0,0,1,.51.36,2,2,0,0,1,.28.8,7.41,7.41,0,0,1,.08,1.11v3.46a.58.58,0,0,1-.07.28.42.42,0,0,1-.16.2l-.63.36a.11.11,0,0,1-.16,0,.24.24,0,0,1-.07-.2v-3.4a1.74,1.74,0,0,0-.22-1.1c-.14-.15-.35-.14-.61,0a1.57,1.57,0,0,0-.57.66,3.27,3.27,0,0,0-.26,1.32v3.46a.75.75,0,0,1-.06.29.45.45,0,0,1-.16.19l-.64.37a.13.13,0,0,1-.16,0,.31.31,0,0,1-.06-.21v-3.4a1.81,1.81,0,0,0-.22-1.1c-.14-.14-.35-.14-.61,0a1.58,1.58,0,0,0-.59.69,3.16,3.16,0,0,0-.24,1.36v3.4a.71.71,0,0,1-.06.28.48.48,0,0,1-.16.2l-.64.36a.12.12,0,0,1-.16,0,.28.28,0,0,1-.07-.2v-6a.77.77,0,0,1,.07-.29.45.45,0,0,1,.16-.19l.64-.37a.12.12,0,0,1,.16,0,.29.29,0,0,1,.06.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.61,160.66q0,1.08,0,2.16a2.73,2.73,0,0,0,.47,1.85c.3.27.7.25,1.22,0a3.05,3.05,0,0,0,.61-.46,2.77,2.77,0,0,0,.5-.61,3.89,3.89,0,0,0,.36-.82,5.94,5.94,0,0,0,.23-1.09,1.05,1.05,0,0,1,.07-.26.28.28,0,0,1,.12-.12l.16-.1c.06,0,.1,0,.13,0s.06.08,0,.16a5.87,5.87,0,0,1-.14,1,6,6,0,0,1-.39,1.12,5.13,5.13,0,0,1-.69,1.07,3.78,3.78,0,0,1-1,.85,1.78,1.78,0,0,1-1,.3,1,1,0,0,1-.68-.33,2.08,2.08,0,0,1-.41-.87,6.14,6.14,0,0,1-.15-1.31c0-.35,0-.72,0-1.12s0-.8,0-1.17a8.94,8.94,0,0,1,.15-1.48,6.16,6.16,0,0,1,.41-1.34,4.65,4.65,0,0,1,.68-1.12,3.41,3.41,0,0,1,1-.83,1.83,1.83,0,0,1,1-.32,1,1,0,0,1,.69.27,1.63,1.63,0,0,1,.39.67,3.59,3.59,0,0,1,.14.87.31.31,0,0,1,0,.21.28.28,0,0,1-.13.15l-.16.1s-.09,0-.12,0,0-.08-.07-.18a2.62,2.62,0,0,0-.23-.82.84.84,0,0,0-.36-.4.7.7,0,0,0-.5-.05,2.53,2.53,0,0,0-.61.26,3.07,3.07,0,0,0-1.22,1.36A5.91,5.91,0,0,0,115.61,160.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.31,155.55a1.4,1.4,0,0,1,.79-.23.83.83,0,0,1,.57.29,1.72,1.72,0,0,1,.36.73,4.84,4.84,0,0,1,.13,1.08,2.09,2.09,0,0,0,0,.24v.6a2.27,2.27,0,0,0,0,.24,7.35,7.35,0,0,1-.13,1.24,5.53,5.53,0,0,1-.36,1.13,3.93,3.93,0,0,1-.57.95,3,3,0,0,1-.79.69,1.43,1.43,0,0,1-.8.23.8.8,0,0,1-.57-.29,1.74,1.74,0,0,1-.36-.72,4.46,4.46,0,0,1-.13-1.09v-.23c0-.1,0-.2,0-.3a2.81,2.81,0,0,1,0-.3v-.25a6.34,6.34,0,0,1,.13-1.23,5.63,5.63,0,0,1,.36-1.14,3.93,3.93,0,0,1,.57-.95A3.09,3.09,0,0,1,122.31,155.55Zm1.34,2.23a2.11,2.11,0,0,0-.39-1.46.73.73,0,0,0-1,0,2.5,2.5,0,0,0-1,1.12,4.91,4.91,0,0,0-.39,1.91c0,.13,0,.29,0,.48s0,.35,0,.47a2.22,2.22,0,0,0,.39,1.46.73.73,0,0,0,1,0,2.49,2.49,0,0,0,1-1.12,4.57,4.57,0,0,0,.39-1.91c0-.13,0-.29,0-.48S123.66,157.9,123.65,157.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,154.38a4.2,4.2,0,0,1,.49-.92,2.22,2.22,0,0,1,.7-.63,1,1,0,0,1,.81-.16,1,1,0,0,1,.53.6,4.21,4.21,0,0,1,.57-1.21,2.54,2.54,0,0,1,.85-.82,1.14,1.14,0,0,1,.62-.18.7.7,0,0,1,.49.24,1.66,1.66,0,0,1,.33.68,4.14,4.14,0,0,1,.13,1.15v3.75a.44.44,0,0,1-.19.39l-.14.08q-.18.1-.18-.18v-3.62a3.72,3.72,0,0,0-.1-1,1.09,1.09,0,0,0-.25-.53.42.42,0,0,0-.36-.14,1.08,1.08,0,0,0-.43.14,1.9,1.9,0,0,0-.39.33,2.46,2.46,0,0,0-.36.56,3.44,3.44,0,0,0-.26.82,5.26,5.26,0,0,0-.1,1.11v3.62a.42.42,0,0,1-.19.39l-.14.08q-.18.1-.18-.18v-3.61a4.28,4.28,0,0,0-.1-1,1.32,1.32,0,0,0-.26-.52.48.48,0,0,0-.37-.14,1,1,0,0,0-.41.14,1.57,1.57,0,0,0-.39.32,2.54,2.54,0,0,0-.36.57,3.35,3.35,0,0,0-.26.81,5.09,5.09,0,0,0-.1,1.1v3.63a.4.4,0,0,1-.19.39l-.14.08c-.12.07-.18,0-.18-.17v-6.13a.41.41,0,0,1,.18-.39l.14-.08c.13-.07.19,0,.19.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,155.42a1.13,1.13,0,0,1-.86.2,1,1,0,0,1-.54-.41v3a.4.4,0,0,1-.19.39l-.14.09q-.18.1-.18-.18V150a.44.44,0,0,1,.18-.4l.14-.08c.13-.07.19,0,.19.18v.61a5,5,0,0,1,.54-1.05,2.58,2.58,0,0,1,.86-.78,1.19,1.19,0,0,1,.83-.21.84.84,0,0,1,.54.37,2.14,2.14,0,0,1,.31.81,6.63,6.63,0,0,1,.11,1c0,.13,0,.27,0,.42s0,.3,0,.43a9.59,9.59,0,0,1-.11,1.18,5.5,5.5,0,0,1-.31,1.16,4.44,4.44,0,0,1-.54,1A2.67,2.67,0,0,1,134.58,155.42Zm-1.4-3.13c0,.13,0,.3,0,.51s0,.37,0,.49a3.4,3.4,0,0,0,.08.73,1.53,1.53,0,0,0,.25.56.73.73,0,0,0,.42.27.82.82,0,0,0,.6-.15,1.92,1.92,0,0,0,.62-.55,3.34,3.34,0,0,0,.4-.75,4.14,4.14,0,0,0,.22-.89,7.45,7.45,0,0,0,.09-.95q0-.36,0-.72a5.14,5.14,0,0,0-.09-.83,1.66,1.66,0,0,0-.22-.63.67.67,0,0,0-.4-.29.88.88,0,0,0-.62.15,2,2,0,0,0-.61.56,3.33,3.33,0,0,0-.41.77,5.69,5.69,0,0,0-.25.87A5.18,5.18,0,0,0,133.18,152.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,152q-.18.1-.18-.18v-.6a4.39,4.39,0,0,1-.2.47,3.5,3.5,0,0,1-.29.49,3.29,3.29,0,0,1-1,.91,1.22,1.22,0,0,1-.58.18.76.76,0,0,1-.47-.13.89.89,0,0,1-.33-.42,1.71,1.71,0,0,1-.12-.69,3.06,3.06,0,0,1,.12-.85,4.09,4.09,0,0,1,.34-.81,5.21,5.21,0,0,1,.52-.74,5.91,5.91,0,0,1,.68-.64l1.32-1v-.45a1.2,1.2,0,0,0-.27-.93q-.27-.22-.87.12a2,2,0,0,0-.72.69,2.26,2.26,0,0,0-.32.78,1.16,1.16,0,0,1-.08.26.27.27,0,0,1-.13.13l-.11.07a.1.1,0,0,1-.13,0,.22.22,0,0,1-.06-.17,2,2,0,0,1,.09-.5,2.82,2.82,0,0,1,.27-.68,3.23,3.23,0,0,1,.48-.72,2.44,2.44,0,0,1,.71-.6,1.59,1.59,0,0,1,.82-.27.69.69,0,0,1,.5.25,1.3,1.3,0,0,1,.26.58,4.42,4.42,0,0,1,.07.74v4.29a.4.4,0,0,1-.19.39Zm-1.58.29a2.07,2.07,0,0,0,.54-.46,3,3,0,0,0,.45-.7,4,4,0,0,0,.3-.92,5.52,5.52,0,0,0,.11-1.12v-.43l-1.08.85a2.94,2.94,0,0,0-1.39,2.17.94.94,0,0,0,.1.49.53.53,0,0,0,.24.25.59.59,0,0,0,.35,0A1.07,1.07,0,0,0,138.77,152.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.62,148.63a.41.41,0,0,1-.18.39l-.15.09q-.18.1-.18-.18v-3.59a2.29,2.29,0,0,0-.33-1.43c-.21-.27-.53-.28-.95,0a2.44,2.44,0,0,0-1,1.14,4.33,4.33,0,0,0-.36,1.83v3.59a.41.41,0,0,1-.18.39l-.15.08c-.12.07-.18,0-.18-.17V144.6a.41.41,0,0,1,.18-.39l.15-.08c.12-.08.18,0,.18.17v.61a5.18,5.18,0,0,1,.54-1,2.6,2.6,0,0,1,.86-.78,1.2,1.2,0,0,1,.75-.21.74.74,0,0,1,.53.3,1.72,1.72,0,0,1,.32.72,5,5,0,0,1,.11,1.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9,149.85a1.27,1.27,0,0,1-.06.18.4.4,0,0,1-.13.13l-.17.09a.07.07,0,0,1-.11,0,.17.17,0,0,1-.05-.15,1.15,1.15,0,0,1,.05-.28l.64-2.69-1.6-4.87a1.21,1.21,0,0,1-.05-.23.54.54,0,0,1,.05-.21.49.49,0,0,1,.12-.15l.18-.1s.09,0,.12,0a.22.22,0,0,1,.07.09l1.4,4.29L149.8,140a.87.87,0,0,1,.07-.17.3.3,0,0,1,.12-.13l.17-.1a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.15,2.43,2.43,0,0,1-.05.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.67,118v8.67c0,1.32.93,1.85,2.07,1.19l7.51-4.33a4.57,4.57,0,0,0,2.07-3.59v-8.67c0-1.32-.92-1.85-2.07-1.19l-7.51,4.33A4.59,4.59,0,0,0,187.67,118Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.87,117.11v-1.29a.09.09,0,0,0-.13-.08l-1,.45a.12.12,0,0,1-.17-.08,2.43,2.43,0,0,0-.22-.49.29.29,0,0,1,0-.24L197,114a.16.16,0,0,0-.06-.19l-.72-.42a.15.15,0,0,0-.2,0l-.83,1.24a.29.29,0,0,1-.21.11,2.05,2.05,0,0,0-.54,0,.12.12,0,0,1-.15-.1l-.11-1.09a.09.09,0,0,0-.13-.07l-1.12.65a.27.27,0,0,0-.13.21l-.11,1.24a.4.4,0,0,1-.12.23,5.56,5.56,0,0,0-.62.66.21.21,0,0,1-.22.06l-.72-.25a.18.18,0,0,0-.2.08l-.82,1.42a.17.17,0,0,0,0,.21l.57.49a.24.24,0,0,1,.06.23,5.31,5.31,0,0,0-.26.86.46.46,0,0,1-.14.22l-1,.72a.27.27,0,0,0-.12.22v1.29a.09.09,0,0,0,.13.08l1-.45a.12.12,0,0,1,.17.08,2.43,2.43,0,0,0,.22.49.26.26,0,0,1,0,.24l-.66,1.34a.15.15,0,0,0,.06.19l.72.42a.17.17,0,0,0,.2,0l.82-1.24a.28.28,0,0,1,.22-.11,2.59,2.59,0,0,0,.54-.05.11.11,0,0,1,.15.1l.11,1.09c0,.07.06.1.13.07l1.12-.65a.33.33,0,0,0,.13-.21l.11-1.24a.4.4,0,0,1,.12-.23,6.52,6.52,0,0,0,.62-.66.21.21,0,0,1,.22-.06l.72.25a.18.18,0,0,0,.2-.08l.82-1.42a.17.17,0,0,0,0-.21l-.57-.5a.21.21,0,0,1-.06-.22,6.54,6.54,0,0,0,.26-.86.42.42,0,0,1,.14-.22l1-.72A.27.27,0,0,0,197.87,117.11Zm-4.37,4.06c-1,.6-1.89.11-1.89-1.09a4.19,4.19,0,0,1,1.89-3.27c1-.6,1.89-.11,1.89,1.09A4.19,4.19,0,0,1,193.5,121.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26,129.25v8.67c0,1.32.93,1.86,2.07,1.2l7.51-4.34a4.57,4.57,0,0,0,2.07-3.58v-8.68c0-1.32-.93-1.85-2.07-1.19l-7.51,4.33A4.59,4.59,0,0,0,168.26,129.25Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.08 131.74 173.13 132.3 173.13 135.03 171.35 136.06 171.35 131.66 170.3 132.27 174.08 125.69 177.87 127.9 176.82 128.5 176.82 132.9 175.04 133.93 175.04 131.19 174.08 131.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,106.82v8.67c0,1.32.93,1.86,2.07,1.2l7.51-4.34a4.57,4.57,0,0,0,2.07-3.58V100.1c0-1.32-.93-1.86-2.07-1.2l-7.51,4.34A4.57,4.57,0,0,0,207.09,106.82Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,102.38a.21.21,0,0,0-.18,0L209.24,107a.71.71,0,0,0-.23.28l4.16,1.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,107.23a.59.59,0,0,0-.07.25V114a.23.23,0,0,0,.08.19l3.29-5.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,102.38,214.11,108l3.22,1.45-3.44-1.07-.48.84a.48.48,0,0,1-.65.18l-.17-.1L209,114.19a.22.22,0,0,0,.22,0l7.89-4.55a.69.69,0,0,0,.3-.52v-6.53A.19.19,0,0,0,217.3,102.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209 107.23 209.01 107.23 209.01 107.23 209 107.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.31 102.37 217.3 102.38 217.3 102.38 217.31 102.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.07 198.58 218.74 115.63 218.74 160.47 75.07 243.41 75.07 198.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.83 234.44 82.83 198.58 129.43 171.68 129.43 207.54 82.83 234.44",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.83 234.44 82.83 198.58 129.43 171.68 129.43 207.54 82.83 234.44",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,189.69c0,1.79,1.26,2.51,2.81,1.62a6.2,6.2,0,0,0,2.81-4.87c0-1.79-1.25-2.52-2.81-1.62A6.22,6.22,0,0,0,116,189.69Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.83 234.44 82.83 220.99 97.14 202.08 113.9 211.5 108.26 206.74 116.36 197.01 129.43 203.8 129.43 207.54 82.83 234.44",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,166l30.8-17.79c1.15-.66,2.07-.19,2.07,1a4.41,4.41,0,0,1-2.07,3.43l-30.8,17.79c-1.15.66-2.07.19-2.07-1A4.42,4.42,0,0,1,139.27,166Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,175.44l71.29-41.16c.69-.39,1.24-.21,1.24.41a2.47,2.47,0,0,1-1.24,1.83l-71.29,41.16c-.69.4-1.24.22-1.24-.4A2.48,2.48,0,0,1,138.44,175.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,179.93l71.29-41.16c.69-.4,1.24-.22,1.24.4a2.48,2.48,0,0,1-1.24,1.84l-71.29,41.16c-.69.39-1.24.21-1.24-.41A2.45,2.45,0,0,1,138.44,179.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,184.41l71.29-41.16c.69-.4,1.24-.22,1.24.4a2.48,2.48,0,0,1-1.24,1.84l-71.29,41.16c-.69.4-1.24.22-1.24-.4A2.46,2.46,0,0,1,138.44,184.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,188.89l40.23-23.24c.68-.39,1.24-.21,1.24.41a2.49,2.49,0,0,1-1.24,1.83l-40.23,23.24c-.69.4-1.24.22-1.24-.4A2.48,2.48,0,0,1,138.44,188.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2,200.67v-1.95a4.55,4.55,0,0,1,2.07-3.58l11.39-6.58c1.14-.66,2.07-.12,2.07,1.2v1.94a4.59,4.59,0,0,1-2.07,3.59l-11.39,6.57C138.12,202.52,137.2,202,137.2,200.67Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,163.83c1.07-.62,1.94-.12,1.94,1.12a4.29,4.29,0,0,1-1.94,3.36c-1.07.62-1.94.12-1.94-1.12A4.29,4.29,0,0,1,197.38,163.83Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07,160.7h0c.52,0,.58.62.58.89a3.82,3.82,0,0,1-1.69,2.93,1.31,1.31,0,0,1-.62.2.47.47,0,0,1-.39-.18,1.18,1.18,0,0,1-.19-.71,3.8,3.8,0,0,1,1.7-2.93,1.25,1.25,0,0,1,.61-.2m0-.5a1.75,1.75,0,0,0-.86.27,4.27,4.27,0,0,0-2,3.36c0,.88.44,1.39,1.08,1.39a1.81,1.81,0,0,0,.87-.27,4.29,4.29,0,0,0,1.94-3.36c0-.88-.44-1.39-1.08-1.39Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,157.34h0c.51,0,.57.62.57.88a3.78,3.78,0,0,1-1.69,2.93,1.31,1.31,0,0,1-.62.2.44.44,0,0,1-.38-.17,1.2,1.2,0,0,1-.19-.71,3.79,3.79,0,0,1,1.69-2.93,1.28,1.28,0,0,1,.62-.2m0-.5a1.76,1.76,0,0,0-.87.26,4.31,4.31,0,0,0-1.94,3.37c0,.87.44,1.38,1.07,1.38a1.76,1.76,0,0,0,.87-.26,4.31,4.31,0,0,0,1.94-3.37c0-.87-.44-1.38-1.07-1.38Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,251.18l38.57-22.26c1.14-.66,2.07-.13,2.07,1.19v35.57a4.57,4.57,0,0,1-2.07,3.59L77.14,291.54c-1.14.66-2.07.12-2.07-1.2V254.77A4.59,4.59,0,0,1,77.14,251.18Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,251.18l38.57-22.26c1.14-.66,2.07-.13,2.07,1.19v35.57a4.57,4.57,0,0,1-2.07,3.59L77.14,291.54c-1.14.66-2.07.12-2.07-1.2V254.77A4.59,4.59,0,0,1,77.14,251.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,252.35c2.17-1.25,3.93-.26,3.93,2.21a8.64,8.64,0,0,1-3.94,6.76c-2.17,1.25-3.93.26-3.93-2.22A8.62,8.62,0,0,1,82.89,252.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,246.7l19.16-11.06c1.14-.66,2.07-.19,2.07,1.05a4.43,4.43,0,0,1-2.07,3.43L92.67,251.18c-1.14.66-2.07.2-2.07-1A4.45,4.45,0,0,1,92.67,246.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.84,253.9l13-7.53c.69-.39,1.24-.21,1.24.4a2.46,2.46,0,0,1-1.24,1.84l-13,7.54c-.68.39-1.24.21-1.24-.41A2.51,2.51,0,0,1,91.84,253.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,267.36l32.47-18.75c.68-.39,1.24-.21,1.24.41a2.47,2.47,0,0,1-1.24,1.83L80.19,269.6c-.68.39-1.24.21-1.24-.41A2.47,2.47,0,0,1,80.19,267.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,271.84l32.47-18.74c.68-.4,1.24-.22,1.24.4a2.51,2.51,0,0,1-1.24,1.84L80.19,274.08c-.68.4-1.24.22-1.24-.4A2.51,2.51,0,0,1,80.19,271.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,276.32l32.47-18.74c.68-.4,1.24-.21,1.24.4a2.49,2.49,0,0,1-1.24,1.84L80.19,278.56c-.68.4-1.24.22-1.24-.4A2.51,2.51,0,0,1,80.19,276.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.65,269.22c-1,.55-1.74-.2-1.74-1.68a4.62,4.62,0,0,1,1.74-3.7c1-.56,1.75.2,1.75,1.68A4.64,4.64,0,0,1,112.65,269.22Zm0-4.86a3.7,3.7,0,0,0-1.41,3c0,1.2.63,1.81,1.41,1.36a3.73,3.73,0,0,0,1.41-3C114.06,264.52,113.43,263.91,112.65,264.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,266.34l-1.73,1c-.1.05-.17,0-.17-.16a.42.42,0,0,1,.17-.36l1.73-1c.1-.06.17,0,.17.16A.45.45,0,0,1,113.43,266.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,267.9a.09.09,0,0,1-.13,0,.4.4,0,0,1,0-.38l.74-1.32-.74-.47c-.07,0-.08-.2,0-.34s.16-.23.23-.18l.91.57s.06.09.06.17a.57.57,0,0,1-.06.24l-.91,1.62A.27.27,0,0,1,112.62,267.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,222l38.57-22.27c1.15-.66,2.07-.12,2.07,1.2v35.57a4.55,4.55,0,0,1-2.07,3.58l-38.54,22.27c-1.15.66-2.07.13-2.07-1.19l0-35.57A4.59,4.59,0,0,1,127.59,222Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.36,223.21c2.17-1.26,3.93-.26,3.93,2.21a8.62,8.62,0,0,1-3.93,6.75c-2.17,1.26-3.93.27-3.93-2.21A8.64,8.64,0,0,1,133.36,223.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15,217.56l19.16-11.06c1.14-.66,2.07-.19,2.07,1a4.45,4.45,0,0,1-2.07,3.44L143.15,222c-1.14.66-2.07.19-2.07-1A4.45,4.45,0,0,1,143.15,217.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,224.76l13.05-7.53c.68-.4,1.24-.22,1.24.4a2.51,2.51,0,0,1-1.24,1.84L142.32,227c-.68.4-1.24.22-1.24-.4A2.48,2.48,0,0,1,142.32,224.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,238.21l32.47-18.74c.68-.4,1.24-.22,1.24.4a2.49,2.49,0,0,1-1.24,1.84l-32.47,18.74c-.68.4-1.24.22-1.24-.4A2.51,2.51,0,0,1,130.67,238.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,242.7,163.14,224c.68-.39,1.24-.21,1.24.41a2.51,2.51,0,0,1-1.24,1.84l-32.47,18.74c-.68.39-1.24.21-1.24-.41A2.47,2.47,0,0,1,130.67,242.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,247.18l32.47-18.74c.68-.4,1.24-.22,1.24.4a2.51,2.51,0,0,1-1.24,1.84l-32.47,18.74c-.68.4-1.24.22-1.24-.4A2.51,2.51,0,0,1,130.67,247.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.13,240.07c-1,.56-1.75-.2-1.75-1.68a4.6,4.6,0,0,1,1.75-3.69c1-.56,1.75.19,1.75,1.68A4.6,4.6,0,0,1,163.13,240.07Zm0-4.86a3.73,3.73,0,0,0-1.41,3c0,1.19.63,1.8,1.41,1.35a3.69,3.69,0,0,0,1.41-3C164.54,235.37,163.91,234.77,163.13,235.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.91,237.19l-1.74,1c-.09.06-.16,0-.16-.16a.43.43,0,0,1,.16-.35l1.74-1c.09,0,.17,0,.17.17A.44.44,0,0,1,163.91,237.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1,238.76a.11.11,0,0,1-.14,0,.44.44,0,0,1,0-.38l.74-1.32-.74-.47c-.07,0-.08-.2,0-.35s.17-.22.24-.18l.91.58s.06.08.06.16a.5.5,0,0,1-.06.24l-.91,1.62A.32.32,0,0,1,163.1,238.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,192.9l38.57-22.27c1.15-.66,2.07-.13,2.07,1.19V207.4a4.55,4.55,0,0,1-2.07,3.58L178.1,233.25c-1.15.66-2.08.13-2.08-1.19L176,196.48A4.57,4.57,0,0,1,178,192.9Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,192.9l38.57-22.27c1.15-.66,2.07-.13,2.07,1.19V207.4a4.55,4.55,0,0,1-2.07,3.58L178.1,233.25c-1.15.66-2.08.13-2.08-1.19L176,196.48A4.57,4.57,0,0,1,178,192.9Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,194.06c2.17-1.25,3.93-.26,3.93,2.22a8.64,8.64,0,0,1-3.93,6.75c-2.17,1.26-3.93.26-3.93-2.21A8.65,8.65,0,0,1,183.84,194.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.63,188.41l19.16-11.06c1.14-.66,2.07-.19,2.07,1.05a4.45,4.45,0,0,1-2.07,3.44L193.63,192.9c-1.15.66-2.07.19-2.07-1.05A4.42,4.42,0,0,1,193.63,188.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,195.62l13-7.54c.68-.39,1.24-.21,1.24.41a2.51,2.51,0,0,1-1.24,1.84l-13,7.53c-.69.4-1.24.21-1.24-.4A2.46,2.46,0,0,1,192.8,195.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,209.07l32.46-18.74c.69-.4,1.25-.22,1.25.4a2.5,2.5,0,0,1-1.25,1.84l-32.46,18.74c-.69.4-1.24.22-1.24-.4A2.46,2.46,0,0,1,181.15,209.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,213.55l32.46-18.74c.69-.4,1.25-.22,1.25.4a2.48,2.48,0,0,1-1.25,1.84l-32.46,18.74c-.69.4-1.24.22-1.24-.4A2.48,2.48,0,0,1,181.15,213.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,218l32.46-18.75c.69-.39,1.25-.21,1.25.41a2.5,2.5,0,0,1-1.25,1.84l-32.46,18.74c-.69.39-1.24.21-1.24-.41A2.45,2.45,0,0,1,181.15,218Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,210.93c-1,.55-1.75-.2-1.75-1.68a4.61,4.61,0,0,1,1.75-3.7c1-.55,1.74.2,1.74,1.68A4.63,4.63,0,0,1,213.61,210.93Zm0-4.86a3.72,3.72,0,0,0-1.41,3c0,1.2.63,1.81,1.41,1.36a3.75,3.75,0,0,0,1.41-3C215,206.23,214.38,205.62,213.61,206.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,208.05l-1.74,1c-.09,0-.17,0-.17-.16a.48.48,0,0,1,.17-.36l1.74-1c.09-.05.17,0,.17.16A.45.45,0,0,1,214.39,208.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,209.61s-.1,0-.13,0a.4.4,0,0,1,0-.38l.74-1.32-.74-.46a.31.31,0,0,1,0-.35c.06-.15.16-.22.24-.18l.91.57a.21.21,0,0,1,.06.17.5.5,0,0,1-.06.24l-.91,1.62A.29.29,0,0,1,213.57,209.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.43,289.41a43.76,43.76,0,0,1,2.28-12.68c2.27-6.6,7-13.36,12.67-14.9s8.38,2.23,7.37,6.12c-.88,3.35-5,6.32-8.15,9.37s-8.84,10.32-10.18,17.12l-3.25.53Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.43,289.41a43.76,43.76,0,0,1,2.28-12.68c2.27-6.6,7-13.36,12.67-14.9s8.38,2.23,7.37,6.12c-.88,3.35-5,6.32-8.15,9.37s-8.84,10.32-10.18,17.12l-3.25.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M449.82,292.31a.37.37,0,0,0,.35-.37c-.29-16.91,15.71-27.22,15.87-27.33a.36.36,0,1,0-.39-.61c-.16.1-16.51,10.64-16.21,28a.35.35,0,0,0,.37.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.74,315.49l.08.1a3.43,3.43,0,0,0,2.32,1,9.2,9.2,0,0,0,6.26-2,17,17,0,0,0,4.27-5.13,14.25,14.25,0,0,1,1.76-2.68c1.5-1.63,4.09-1.73,6.11-2.28a7.82,7.82,0,0,0,5.62-5.42c.63-2.66.15-5.84-2.37-7.39l2-1.44a13.26,13.26,0,0,0,2.55-2.17,4.54,4.54,0,0,0,1.18-3.05,4.39,4.39,0,0,0-2.93-3.65,9.27,9.27,0,0,0-4.88-.23,22,22,0,0,0-4.78,1.39,3.26,3.26,0,0,1-1.34.38,3.52,3.52,0,0,1-1.7-.67c-3.67-2.15-9.44-1.67-11.11,2.85-.24.66-.37,1.37-.64,2-1,2.44-4.12,1.89-6.06,3.11a5.08,5.08,0,0,0-2.14,3.76c-.27,2.37.53,5,1.09,7.32s1.22,4.43,2,6.61q.92,2.69,2,5.32A10.73,10.73,0,0,0,450.74,315.49Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.45,310.07a32.72,32.72,0,0,1,7.79-13.21.37.37,0,0,1,.19-.2,43,43,0,0,1,3.28-3.09,17.57,17.57,0,0,0-1.66-9.18.36.36,0,0,1,.64-.34,18.06,18.06,0,0,1,1.81,8.86A56.19,56.19,0,0,1,476,284.06a.37.37,0,0,1,.46.23.36.36,0,0,1-.23.46,54.29,54.29,0,0,0-18.39,11.47c5.16-1.19,11.52,1,11.81,1.09a.38.38,0,0,1,.23.47.37.37,0,0,1-.33.24.36.36,0,0,1-.14,0c-.07,0-7.54-2.59-12.62-.72a32.07,32.07,0,0,0-7.68,13,.36.36,0,0,1-.33.26h-.12A.37.37,0,0,1,448.45,310.07Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.21,144.76V280.83a4.88,4.88,0,0,0,2.19,3.8l60.34,34.83c1.21.7,2.19.14,2.19-1.26V182.13a4.88,4.88,0,0,0-2.19-3.81L381.4,143.49C380.2,142.79,379.21,143.36,379.21,144.76ZM382.37,161c0-1.2.84-1.69,1.88-1.08l54.86,31.66a4.17,4.17,0,0,1,1.88,3.26v106.6c0,1.2-.84,1.68-1.88,1.08l-54.86-31.67a3,3,0,0,1-1.88-2.56Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.21,144.76V280.83a4.88,4.88,0,0,0,2.19,3.8l60.34,34.83c1.21.7,2.19.14,2.19-1.26V182.13a4.88,4.88,0,0,0-2.19-3.81L381.4,143.49C380.2,142.79,379.21,143.36,379.21,144.76ZM382.37,161c0-1.2.84-1.69,1.88-1.08l54.86,31.66a4.17,4.17,0,0,1,1.88,3.26v106.6c0,1.2-.84,1.68-1.88,1.08l-54.86-31.67a3,3,0,0,1-1.88-2.56Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,319.6a4.94,4.94,0,0,0,4.12-.13l2.51-1.45a4.85,4.85,0,0,0,2.2-3.81V178.15a4.12,4.12,0,0,0-.38-1.64,4.32,4.32,0,0,0-.26-.53h0l-6.91,4h0c.14.27.27.54.38.81a4.14,4.14,0,0,1,.26,1.36V318.2C443.93,319.49,443.1,320.07,442,319.6Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,319.6a4.94,4.94,0,0,0,4.12-.13l2.51-1.45a4.85,4.85,0,0,0,2.2-3.81V178.15a4.12,4.12,0,0,0-.38-1.64,4.32,4.32,0,0,0-.26-.53h0l-6.91,4h0c.14.27.27.54.38.81a4.14,4.14,0,0,1,.26,1.36V318.2C443.93,319.49,443.1,320.07,442,319.6Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,299.06a3.64,3.64,0,0,1-1.8-.54,8.1,8.1,0,0,1-3.71-6.43,2.94,2.94,0,0,1,1.26-2.68,2.9,2.9,0,0,1,2.95.25h0a8.1,8.1,0,0,1,3.71,6.43,2.92,2.92,0,0,1-1.26,2.68A2.29,2.29,0,0,1,412.6,299.06Zm-3.09-8.94a1.29,1.29,0,0,0-.66.16,2,2,0,0,0-.76,1.81,7.13,7.13,0,0,0,3.21,5.57,1.63,1.63,0,0,0,2.71-1.57,7.13,7.13,0,0,0-3.21-5.57h0A2.65,2.65,0,0,0,409.51,290.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.57,163.84c-.81-.47-1.47-.09-1.47.85a3.26,3.26,0,0,0,1.47,2.55c.81.47,1.47.09,1.47-.85A3.26,3.26,0,0,0,411.57,163.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.25,172.79l-11.36-6.56c-.67-.39-1.22-.11-1.22.62a2.64,2.64,0,0,0,1.22,2l11.36,6.56c.68.39,1.23.11,1.23-.62A2.62,2.62,0,0,0,417.25,172.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,268.29a3,3,0,0,0,1.88,2.56l54.86,31.67c1,.6,1.88.12,1.88-1.08V194.84a4.17,4.17,0,0,0-1.88-3.26l-54.86-31.66c-1-.61-1.88-.12-1.88,1.08Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,268.29a3,3,0,0,0,1.88,2.56l54.86,31.67c1,.6,1.88.12,1.88-1.08V194.84a4.17,4.17,0,0,0-1.88-3.26l-54.86-31.66c-1-.61-1.88-.12-1.88,1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,144.41c.16-1.14,1.07-1.55,2.17-.92l60.34,34.83a4.46,4.46,0,0,1,1.55,1.64l6.91-4a4.46,4.46,0,0,0-1.56-1.63l-60.33-34.84a4.85,4.85,0,0,0-4.39,0L381.4,141A4.92,4.92,0,0,0,379.23,144.41Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,144.41c.16-1.14,1.07-1.55,2.17-.92l60.34,34.83a4.46,4.46,0,0,1,1.55,1.64l6.91-4a4.46,4.46,0,0,0-1.56-1.63l-60.33-34.84a4.85,4.85,0,0,0-4.39,0L381.4,141A4.92,4.92,0,0,0,379.23,144.41Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,191.58l-54.86-31.66c-1-.61-1.88-.12-1.88,1.08v12.31L441,207.15V194.84A4.17,4.17,0,0,0,439.11,191.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,172.9a4.34,4.34,0,0,0,2.06,3.31l34.7,20.28c1.14.66,2.07.2,2.07-1a4.43,4.43,0,0,0-2.07-3.43l-34.69-20C390.59,171.33,389.67,171.74,389.67,172.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.64,209.42v10a4.72,4.72,0,0,0,1.79,3.79l6.5,3.76c1,.57,1.8-.21,1.8-1.73v-10a4.75,4.75,0,0,0-1.8-3.8l-6.5-3.75C407.44,207.13,406.64,207.9,406.64,209.42Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.46,220.27v-1.49a.32.32,0,0,0-.11-.24l-.86-.64a.53.53,0,0,1-.14-.29,8.09,8.09,0,0,0-.19-.82.54.54,0,0,1,0-.3l.58-.77a.38.38,0,0,0-.05-.29l-.63-1.32c-.05-.12-.13-.2-.17-.18l-.71.47s-.12,0-.19-.13a6.54,6.54,0,0,0-.46-.56.48.48,0,0,1-.13-.3l-.1-1.38a.32.32,0,0,0-.11-.23l-1-.56c-.06,0-.11,0-.12.08l-.09,1.31c0,.08-.06.14-.1.13a1.38,1.38,0,0,0-.54,0s-.13-.07-.19-.19l-.62-1.12c-.07-.12-.14-.18-.18-.15l-.71.68s0,.16,0,.29l.5,1.24a.6.6,0,0,1,.05.32,3.38,3.38,0,0,0-.22.7c0,.07-.07.11-.13.08l-.88-.36c-.06,0-.1,0-.1.12v1.49a.36.36,0,0,0,.11.25l.86.64a.49.49,0,0,1,.14.28,7.72,7.72,0,0,0,.2.83.48.48,0,0,1,0,.29l-.58.77a.49.49,0,0,0,.06.3l.62,1.32c.06.12.13.2.17.17l.71-.47s.13,0,.19.13a6.62,6.62,0,0,0,.47.56.63.63,0,0,1,.13.3l.09,1.38a.35.35,0,0,0,.12.24l1,.56c.05,0,.1,0,.11-.09l.1-1.3c0-.09.05-.14.1-.14a1.39,1.39,0,0,0,.54,0s.12.07.19.18l.62,1.13c.06.11.14.18.17.15l.71-.69s0-.16,0-.28l-.5-1.25a.59.59,0,0,1-.05-.32,3.38,3.38,0,0,0,.23-.7.09.09,0,0,1,.12-.08l.89.36C415.42,220.41,415.46,220.36,415.46,220.27Zm-3.78-.41a4.31,4.31,0,0,1-1.63-3.46c0-1.39.73-2.09,1.63-1.57a4.32,4.32,0,0,1,1.64,3.46C413.32,219.68,412.58,220.38,411.68,219.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.82,199.74v10a4.73,4.73,0,0,0,1.8,3.79l6.5,3.76c1,.57,1.79-.2,1.79-1.73v-10a4.74,4.74,0,0,0-1.79-3.8l-6.5-3.75C390.63,197.45,389.82,198.22,389.82,199.74Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.87 209.42 394.04 208.94 394.04 212.1 392.5 211.21 392.5 206.13 391.59 205.61 394.87 202.42 398.15 209.39 397.24 208.87 397.24 213.95 395.7 213.06 395.7 209.9 394.87 209.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.45,219.15v10a4.72,4.72,0,0,0,1.79,3.79l6.51,3.76c1,.57,1.79-.2,1.79-1.73V225a4.72,4.72,0,0,0-1.79-3.79l-6.51-3.76C424.25,216.85,423.45,217.62,423.45,219.15Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,225.93a.36.36,0,0,0-.16-.18l-6.81-3.94a.14.14,0,0,0-.2.06l3.6,6.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.12,221.87a.26.26,0,0,0-.07.19v7.52a.87.87,0,0,0,.07.31l2.86-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.3,225.93l-2.77,2.71,2.79,5.44-3-5.26-.42.42c-.11.11-.36-.14-.56-.55l-.15-.32-3.1,1.52a.53.53,0,0,0,.19.24l6.83,4c.15.08.27,0,.27-.25V226.3A.79.79,0,0,0,432.3,225.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.11 221.85 425.12 221.87 425.12 221.87 425.11 221.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.3 225.93 432.3 225.93 432.3 225.93 432.3 225.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.72,165.36v-.78c0-.17.06-.27.15-.22l0,0a.51.51,0,0,1,.15.39v.78c0,.17-.07.27-.15.22l0,0A.47.47,0,0,1,384.72,165.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.4,165.75V164.4c0-.17.06-.27.14-.22l0,0a.52.52,0,0,1,.15.39V166c0,.16-.07.26-.15.22l0,0A.5.5,0,0,1,385.4,165.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.08,166.14v-1.92c0-.17.06-.27.14-.22l0,0c.08,0,.14.22.14.39v1.92c0,.17-.06.27-.14.22l0,0C386.14,166.49,386.08,166.31,386.08,166.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.75,166.53v-3.31c0-.17.07-.27.15-.22l.05,0a.53.53,0,0,1,.14.4v3.31c0,.17-.06.27-.15.22l0,0A.53.53,0,0,1,386.75,166.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.59,167.82a.37.37,0,0,1,0-.12v-.49l-.76-.44s-.06-.07-.06-.14v-.17a.22.22,0,0,1,0-.09.14.14,0,0,1,0-.06l.81-1.28,0,0h.05l.11.07a.16.16,0,0,1,.07.07.52.52,0,0,1,0,.14V167l.17.09a.27.27,0,0,1,.07.08.45.45,0,0,1,0,.13v.11a.22.22,0,0,1,0,.1s0,0-.07,0l-.17-.1v.49a.22.22,0,0,1,0,.1s0,0-.07,0l-.13-.07A.27.27,0,0,1,388.59,167.82Zm0-1v-1.22l-.55.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5,168.05a3.17,3.17,0,0,1-.23-1.25,1.55,1.55,0,0,1,.23-1q.22-.27.63,0a1.33,1.33,0,0,1,.3.23,1.36,1.36,0,0,1,.24.31.19.19,0,0,1,0,.07.08.08,0,0,1,0,0l-.07.17s0,0,0,0l0,0a1.21,1.21,0,0,0-.39-.39c-.18-.1-.32-.1-.43,0a1.25,1.25,0,0,0-.15.74,2.44,2.44,0,0,0,.15.93,1,1,0,0,0,.41.51,1,1,0,0,0,.19.08.27.27,0,0,0,.15,0v-.79l-.32-.19a.11.11,0,0,1-.06-.07.25.25,0,0,1,0-.13v-.11c0-.05,0-.09,0-.1s0,0,.06,0l.51.3a.24.24,0,0,1,.08.09.49.49,0,0,1,0,.15v1.12a.25.25,0,0,1,0,.1s0,0,0,0a.64.64,0,0,1-.6-.1A1.56,1.56,0,0,1,389.5,168.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,193.41a.86.86,0,0,0-.3-.45l-2.28-1.32c-.2-.11-.35.12-.35.52v1.71a2.1,2.1,0,0,0,.13.69,2,2,0,0,0,.12.25.6.6,0,0,0,.18.2l2.28,1.32c.2.11.35-.12.35-.52V194.1A1.87,1.87,0,0,0,438,193.41Zm-2.72,1a.93.93,0,0,1,0-.31v-1.7c0-.3.12-.48.26-.4l2.28,1.32a.32.32,0,0,1,.1.1.3.3,0,0,1,0,.08.91.91,0,0,1,.05.31v1.7c0,.3-.12.48-.27.4l-2.28-1.32A.38.38,0,0,1,435.26,194.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7,193.05v2l-1.22-.71s0,0,0,0v-1.6c0-.22.09-.35.19-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.23,194.18a1.22,1.22,0,0,1,.15.72v.32c0,.35-.07.6-.15.56l-.16-.08v-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.85,170.32c0,.38-.19.57-.44.43a1.18,1.18,0,0,1-.44-.94c0-.37.2-.56.44-.42A1.14,1.14,0,0,1,393.85,170.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.41,168.27a.68.68,0,0,0-1,.36.48.48,0,0,0,.05.36h0c.09.15.21.19.26.07a.47.47,0,0,1,.72-.25,1.86,1.86,0,0,1,.73,1.09c.05.17.17.28.25.23h0a.29.29,0,0,0,.05-.31A2.68,2.68,0,0,0,393.41,168.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.41,167.18a1.05,1.05,0,0,0-1.58.43.48.48,0,0,0,0,.38h0c.08.15.2.18.26.08a.85.85,0,0,1,1.28-.35,3.36,3.36,0,0,1,1.29,1.83c.06.17.17.27.25.22h0c.08-.05.09-.19,0-.34A4.14,4.14,0,0,0,393.41,167.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.72,179.36a.08.08,0,0,1,0,.07h-.05l-.11-.06a.13.13,0,0,1-.05-.07.16.16,0,0,1,0-.09v-2.33l-.44.27s0,0-.06,0l0-.07-.06-.17a.29.29,0,0,1,0-.09.16.16,0,0,1,0-.06l.59-.36h0l.05,0,.11.07a.1.1,0,0,1,.05.06.15.15,0,0,1,0,.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.37,177.86a.1.1,0,0,1,.05.06.19.19,0,0,1,0,.1v.28a.09.09,0,0,1,0,.07h-.05l-.18-.11a.1.1,0,0,1-.05-.06.16.16,0,0,1,0-.09v-.29a.06.06,0,0,1,0-.06s0,0,.05,0Zm0,1.48a.1.1,0,0,1,.05.06.16.16,0,0,1,0,.09v.29a.06.06,0,0,1,0,.06s0,0-.05,0l-.18-.11a.1.1,0,0,1-.05-.06.16.16,0,0,1,0-.09v-.29a.06.06,0,0,1,0-.06s0,0,.05,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.72,180.63a.1.1,0,0,1-.05-.07.29.29,0,0,1,0-.09v-.58l-.86-.5a.17.17,0,0,1-.06-.06.3.3,0,0,1,0-.1v-.15s0,0,0-.06l0-.06.87-1.25a.07.07,0,0,1,.05,0h.05l.11.07a.17.17,0,0,1,.06.06.29.29,0,0,1,0,.09v1.77l.23.14a.17.17,0,0,1,.06.06.29.29,0,0,1,0,.09v.15a.12.12,0,0,1,0,.07,0,0,0,0,1-.06,0l-.23-.14v.58a.12.12,0,0,1,0,.07h-.06Zm-.07-1.12v-1.19l-.6.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.68,180.47a.83.83,0,0,0,0,.15.61.61,0,0,0,.07.17.83.83,0,0,0,.13.16,1,1,0,0,0,.21.15.29.29,0,0,0,.16.06.17.17,0,0,0,.14,0,.35.35,0,0,0,.09-.11.65.65,0,0,0,0-.22,1,1,0,0,0,0-.25.72.72,0,0,0-.09-.2.7.7,0,0,0-.13-.16.66.66,0,0,0-.17-.12l-.23-.14a.1.1,0,0,1,0-.06.29.29,0,0,1,0-.09v-.15s0,0,0-.06l0-.05.5-.53-.79-.46-.06-.06a.29.29,0,0,1,0-.09v-.15a.1.1,0,0,1,0-.07,0,0,0,0,1,.06,0l1.08.63s0,0,0,.06a.29.29,0,0,1,0,.09v.16a.13.13,0,0,1,0,.06.1.1,0,0,1,0,.05l-.48.53a1,1,0,0,1,.25.21,1.38,1.38,0,0,1,.19.28,1.33,1.33,0,0,1,.13.35,1.58,1.58,0,0,1,0,.38,1.25,1.25,0,0,1-.05.36.46.46,0,0,1-.15.2.3.3,0,0,1-.21,0,.48.48,0,0,1-.27-.09,1.31,1.31,0,0,1-.32-.25,1.29,1.29,0,0,1-.22-.3,1.37,1.37,0,0,1-.13-.31,1.77,1.77,0,0,1,0-.3s0,0,0,0,0,0,0,0l.13.08a.1.1,0,0,1,0,0A.26.26,0,0,1,411.68,180.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.82 260.65 389.82 218.63 433.56 243.88 433.56 285.9 389.82 260.65",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.82 260.65 389.82 218.63 433.56 243.88 433.56 285.9 389.82 260.65",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,246.63c0,2.24,1.18,4.74,2.64,5.58s2.64-.3,2.64-2.54-1.18-4.74-2.64-5.58S421,244.38,421,246.63Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.82 260.65 389.82 243.82 403.25 238.23 418.98 271.21 413.69 258.13 421.29 256.19 433.56 281.21 433.56 285.9 389.82 260.65",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,272.65a4.64,4.64,0,0,1,1.95,3.71c0,1.43-.87,2.09-1.94,1.47a4.64,4.64,0,0,1-1.95-3.71C403.45,272.69,404.32,272,405.39,272.65Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.45,275.78v.5a1.18,1.18,0,0,1,.52.16,4.16,4.16,0,0,1,1.69,3.28,1.7,1.7,0,0,1-.23,1,.53.53,0,0,1-.44.24,1.18,1.18,0,0,1-.52-.16,4.16,4.16,0,0,1-1.69-3.28c0-.55.17-1.2.67-1.2v-.5m0,0c-.69,0-1.17.63-1.17,1.7a4.66,4.66,0,0,0,1.94,3.71,1.51,1.51,0,0,0,.77.23c.69,0,1.17-.63,1.17-1.7a4.66,4.66,0,0,0-1.94-3.71,1.54,1.54,0,0,0-.77-.23Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.27,279.64h0a1,1,0,0,1,.52.17,4.16,4.16,0,0,1,1.69,3.27,1.7,1.7,0,0,1-.23,1,.49.49,0,0,1-.44.24,1.06,1.06,0,0,1-.52-.16,4.19,4.19,0,0,1-1.69-3.28c0-.55.18-1.2.67-1.2m0-.5c-.69,0-1.17.64-1.17,1.7a4.66,4.66,0,0,0,1.94,3.71,1.56,1.56,0,0,0,.77.23c.69,0,1.17-.63,1.17-1.7a4.66,4.66,0,0,0-1.94-3.71,1.61,1.61,0,0,0-.77-.23Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,185.45c0,2.1,1.11,4.43,2.47,5.22s2.46-.28,2.46-2.37-1.1-4.43-2.46-5.22S387.81,183.36,387.81,185.45Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.51,186.5a1.91,1.91,0,0,0,.71,1.52c.4.23.72-.08.72-.69a1.85,1.85,0,0,0-.72-1.51C390.83,185.59,390.51,185.9,390.51,186.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.15,193.88a.32.32,0,0,1,.1.15.85.85,0,0,1,0,.23V195a.4.4,0,0,1,0,.18s-.07.06-.1,0l-2.33-1.34a.27.27,0,0,1-.1-.14.62.62,0,0,1,0-.23v-7a.3.3,0,0,1,0-.18.07.07,0,0,1,.1,0l.43.25a.27.27,0,0,1,.1.14.64.64,0,0,1,0,.23v6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,190.52a1.64,1.64,0,0,1,.53.49,3.36,3.36,0,0,1,.41.75,5,5,0,0,1,.28.92,6.79,6.79,0,0,1,.12,1v1.1a4.21,4.21,0,0,1-.13.86,1.52,1.52,0,0,1-.27.6.65.65,0,0,1-.41.27.8.8,0,0,1-.53-.12,1.6,1.6,0,0,1-.52-.49,3.08,3.08,0,0,1-.41-.74,4.37,4.37,0,0,1-.27-.91,6.8,6.8,0,0,1-.13-1V193c0-.1,0-.2,0-.3s0-.2,0-.3v-.25a3.65,3.65,0,0,1,.12-.87,1.67,1.67,0,0,1,.28-.6.71.71,0,0,1,.41-.28A.76.76,0,0,1,400,190.52Zm.65,2.82a3.23,3.23,0,0,0-.08-.6,2.05,2.05,0,0,0-.15-.44,1.2,1.2,0,0,0-.2-.3.87.87,0,0,0-.22-.17.6.6,0,0,0-.21-.08.26.26,0,0,0-.2.07.56.56,0,0,0-.15.27,1.94,1.94,0,0,0-.08.51,1.62,1.62,0,0,1,0,.21v.55a2,2,0,0,1,0,.22,3.35,3.35,0,0,0,.08.61,2.05,2.05,0,0,0,.15.44,1.13,1.13,0,0,0,.2.29,1.68,1.68,0,0,0,.21.18.7.7,0,0,0,.22.07.25.25,0,0,0,.2-.06.68.68,0,0,0,.15-.27,2.11,2.11,0,0,0,.08-.52v-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.19,193.8q-.31-.18-.45,0a1.63,1.63,0,0,0-.14.86v2.83a.3.3,0,0,1-.05.18.07.07,0,0,1-.1,0l-.4-.23a.3.3,0,0,1-.1-.15.59.59,0,0,1,0-.23v-5.07a.36.36,0,0,1,0-.19s.06-.05.1,0l.4.23a.27.27,0,0,1,.1.14.64.64,0,0,1,.05.23v.26a.63.63,0,0,1,.29-.24.55.55,0,0,1,.41.1l.24.14a.27.27,0,0,1,.1.14.62.62,0,0,1,0,.23v.72a.3.3,0,0,1,0,.18.07.07,0,0,1-.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.94,195.76a6.12,6.12,0,0,1,.09-1.1,2.63,2.63,0,0,1,.26-.78.85.85,0,0,1,.41-.39.6.6,0,0,1,.54.08,1.6,1.6,0,0,1,.54.53,3.86,3.86,0,0,1,.41.84,6.2,6.2,0,0,1,.26,1,6.14,6.14,0,0,1,.1,1.12v.49a.3.3,0,0,1-.05.18.07.07,0,0,1-.1,0l-1.77-1a2.42,2.42,0,0,0,.05.47,2.35,2.35,0,0,0,.14.4,1.35,1.35,0,0,0,.19.31,1,1,0,0,0,.23.19.45.45,0,0,0,.28.09.25.25,0,0,0,.17-.08l.1-.06a.14.14,0,0,1,.1,0l.42.25a.27.27,0,0,1,.11.15.57.57,0,0,1,0,.22,1.06,1.06,0,0,1-.09.35.76.76,0,0,1-.23.33.71.71,0,0,1-.38.18.87.87,0,0,1-.52-.14,1.77,1.77,0,0,1-.54-.52,4,4,0,0,1-.41-.85A6.11,6.11,0,0,1,404,197,8.22,8.22,0,0,1,403.94,195.76Zm1.3-.88a.34.34,0,0,0-.26-.06.32.32,0,0,0-.18.13.89.89,0,0,0-.12.26c0,.11,0,.21-.05.32l1.2.69c0-.12,0-.24,0-.37a2.34,2.34,0,0,0-.09-.38,1.83,1.83,0,0,0-.18-.34A.84.84,0,0,0,405.24,194.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.81,195.71a.62.62,0,0,1,.31-.31.44.44,0,0,1,.38,0,1.49,1.49,0,0,1,.54.57,3.15,3.15,0,0,1,.34.86.92.92,0,0,1,.17-.29.78.78,0,0,1,.21-.17.41.41,0,0,1,.24,0,.55.55,0,0,1,.24.07,1.49,1.49,0,0,1,.5.5,3.21,3.21,0,0,1,.33.75,4.9,4.9,0,0,1,.17.91,8.27,8.27,0,0,1,.05,1v2.93a.3.3,0,0,1,0,.18.07.07,0,0,1-.1,0l-.4-.23a.22.22,0,0,1-.1-.15.59.59,0,0,1,0-.23v-2.87a3.52,3.52,0,0,0-.13-1.12.92.92,0,0,0-.39-.51.24.24,0,0,0-.36.07,1.65,1.65,0,0,0-.17.9v2.93a.3.3,0,0,1,0,.18.07.07,0,0,1-.1,0l-.4-.24a.27.27,0,0,1-.1-.14.64.64,0,0,1-.05-.23v-2.88a3.49,3.49,0,0,0-.13-1.11,1,1,0,0,0-.39-.52.26.26,0,0,0-.37.09,1.83,1.83,0,0,0-.16.94v2.87a.3.3,0,0,1,0,.18s-.06.06-.1,0l-.4-.23a.26.26,0,0,1-.1-.15.59.59,0,0,1-.05-.23v-5.07a.3.3,0,0,1,.05-.18.07.07,0,0,1,.1,0l.4.23a.26.26,0,0,1,.1.15.59.59,0,0,1,0,.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,199.4q0,.89,0,1.83a5.7,5.7,0,0,0,.3,2,1.89,1.89,0,0,0,.77,1,1,1,0,0,0,.39.14.36.36,0,0,0,.31-.1.8.8,0,0,0,.23-.38,3.29,3.29,0,0,0,.15-.73.3.3,0,0,1,0-.15.08.08,0,0,1,.08,0l.1.07a.22.22,0,0,1,.09.1.36.36,0,0,1,0,.18,3.2,3.2,0,0,1-.09.75,1.54,1.54,0,0,1-.25.61.72.72,0,0,1-.43.32.87.87,0,0,1-.64-.15,1.9,1.9,0,0,1-.62-.58,3.21,3.21,0,0,1-.43-.87,4.75,4.75,0,0,1-.26-1.08,9.57,9.57,0,0,1-.1-1.23c0-.3,0-.62,0-1s0-.66,0-1a7.28,7.28,0,0,1,.1-1.12,2.15,2.15,0,0,1,.26-.79.72.72,0,0,1,.43-.36.8.8,0,0,1,.62.13,2,2,0,0,1,.64.6,3.49,3.49,0,0,1,.43.81,4.32,4.32,0,0,1,.25.9,4.49,4.49,0,0,1,.09.86.19.19,0,0,1,0,.14.06.06,0,0,1-.09,0l-.1-.06a.15.15,0,0,1-.08-.09.69.69,0,0,1,0-.2,6,6,0,0,0-.15-.9,3.07,3.07,0,0,0-.23-.65A1.76,1.76,0,0,0,415,198a2.31,2.31,0,0,0-.39-.31c-.33-.18-.58-.15-.77.12A3.12,3.12,0,0,0,413.53,199.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.78,200.8a1.79,1.79,0,0,1,.5.49,3.31,3.31,0,0,1,.36.73,4.77,4.77,0,0,1,.22.92,5.8,5.8,0,0,1,.09,1,1.7,1.7,0,0,0,0,.21v.5a1.56,1.56,0,0,0,0,.2,4.31,4.31,0,0,1-.09.93,1.88,1.88,0,0,1-.22.66.68.68,0,0,1-.36.32.61.61,0,0,1-.5-.11,1.55,1.55,0,0,1-.51-.48,3.31,3.31,0,0,1-.36-.73,5.62,5.62,0,0,1-.23-.92,6.93,6.93,0,0,1-.08-1v-.2a2.17,2.17,0,0,1,0-.26,2,2,0,0,1,0-.25v-.2a5.12,5.12,0,0,1,.08-.93,2.1,2.1,0,0,1,.23-.66.58.58,0,0,1,.87-.22Zm.85,3a4.56,4.56,0,0,0-.25-1.57,1.59,1.59,0,0,0-.6-.83.41.41,0,0,0-.61.13,2.52,2.52,0,0,0-.25,1.28v.81a4.55,4.55,0,0,0,.25,1.56,1.54,1.54,0,0,0,.61.83.4.4,0,0,0,.6-.13,2.49,2.49,0,0,0,.25-1.28v-.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,202.82a.68.68,0,0,1,.31-.35.48.48,0,0,1,.45.06,1.47,1.47,0,0,1,.51.56,3.59,3.59,0,0,1,.33,1,1,1,0,0,1,.36-.54.5.5,0,0,1,.55,0,1.27,1.27,0,0,1,.39.38,2.64,2.64,0,0,1,.31.63,4.59,4.59,0,0,1,.21.85,7.2,7.2,0,0,1,.08,1.08v3.17c0,.16,0,.21-.12.17l-.09,0a.34.34,0,0,1-.12-.31V206.4a6.21,6.21,0,0,0-.05-.92,4,4,0,0,0-.16-.66,1.89,1.89,0,0,0-.23-.43,1.07,1.07,0,0,0-.28-.25.42.42,0,0,0-.24,0,.31.31,0,0,0-.23.17,1.26,1.26,0,0,0-.17.47,4.73,4.73,0,0,0-.06.85v3.06c0,.16,0,.21-.12.17l-.09-.05a.34.34,0,0,1-.12-.31v-3.06a6.07,6.07,0,0,0-.06-.92,4.14,4.14,0,0,0-.16-.67,1.89,1.89,0,0,0-.23-.43,1,1,0,0,0-.27-.24.42.42,0,0,0-.24,0,.31.31,0,0,0-.23.17,1.2,1.2,0,0,0-.17.46,4.73,4.73,0,0,0-.06.85v3.07c0,.16,0,.21-.12.17l-.09-.05a.34.34,0,0,1-.12-.31v-5.18q0-.24.12-.18l.09.06q.12.06.12.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.56,211.18a1.49,1.49,0,0,1-.54-.57,3.4,3.4,0,0,1-.35-.8v2.58c0,.16,0,.21-.12.17l-.09-.05c-.08,0-.11-.15-.11-.31V205c0-.16,0-.22.11-.17l.09.05c.08,0,.12.15.12.3v.52a.83.83,0,0,1,.35-.42.53.53,0,0,1,.54.07,1.39,1.39,0,0,1,.52.53,3.08,3.08,0,0,1,.35.78,5.59,5.59,0,0,1,.19.94,8.42,8.42,0,0,1,.08,1v.72a6.55,6.55,0,0,1-.08.9,2.52,2.52,0,0,1-.19.71.75.75,0,0,1-.35.39A.57.57,0,0,1,425.56,211.18Zm-.89-3.85c0,.11,0,.25,0,.43s0,.31,0,.42a4.2,4.2,0,0,0,.06.69,3.66,3.66,0,0,0,.15.69,2.58,2.58,0,0,0,.27.58,1.09,1.09,0,0,0,.38.39.42.42,0,0,0,.39.06.52.52,0,0,0,.25-.29,2,2,0,0,0,.15-.56,5.58,5.58,0,0,0,.05-.73c0-.2,0-.4,0-.61a6.81,6.81,0,0,0-.05-.78,3.82,3.82,0,0,0-.15-.72,2.44,2.44,0,0,0-.25-.59,1,1,0,0,0-.39-.4.44.44,0,0,0-.39,0,.71.71,0,0,0-.26.3,2,2,0,0,0-.15.53A3.39,3.39,0,0,0,424.67,207.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.22,213.18q-.12-.06-.12-.3v-.51a1,1,0,0,1-.12.23.49.49,0,0,1-.19.16.44.44,0,0,1-.26.05.72.72,0,0,1-.36-.13,1.24,1.24,0,0,1-.37-.33,2.84,2.84,0,0,1-.3-.52,2.91,2.91,0,0,1-.21-.63,3.17,3.17,0,0,1-.07-.69,2.25,2.25,0,0,1,.07-.62,1,1,0,0,1,.22-.39.6.6,0,0,1,.33-.18.94.94,0,0,1,.43,0l.83.24v-.38a2.57,2.57,0,0,0-.17-1,1.26,1.26,0,0,0-.55-.65c-.2-.11-.35-.12-.46,0a.66.66,0,0,0-.2.39.28.28,0,0,1-.05.15.06.06,0,0,1-.08,0l-.07,0a.23.23,0,0,1-.08-.12.41.41,0,0,1,0-.19,1.72,1.72,0,0,1,.05-.35,1,1,0,0,1,.18-.34.55.55,0,0,1,.3-.2.57.57,0,0,1,.45.1,1.67,1.67,0,0,1,.52.47,2.56,2.56,0,0,1,.32.64,3.47,3.47,0,0,1,.16.71,5.6,5.6,0,0,1,.05.69v3.62q0,.24-.12.18Zm-1-1.1a.41.41,0,0,0,.62-.14,1.34,1.34,0,0,0,.2-.52,5,5,0,0,0,.06-.85v-.37l-.68-.2c-.59-.17-.88,0-.88.65a2,2,0,0,0,.06.5,1.92,1.92,0,0,0,.16.42,1.2,1.2,0,0,0,.21.31A1,1,0,0,0,428.22,212.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,214.87c0,.16,0,.22-.11.18l-.09-.06q-.12-.06-.12-.3v-3a4.65,4.65,0,0,0-.21-1.49,1.46,1.46,0,0,0-.6-.84.4.4,0,0,0-.61.14,2.46,2.46,0,0,0-.23,1.24v3c0,.15,0,.21-.12.17l-.09-.06c-.08,0-.11-.14-.11-.3v-5.18c0-.16,0-.22.11-.18l.09.06q.12.06.12.3v.51a1,1,0,0,1,.34-.42.55.55,0,0,1,.55.08,1.29,1.29,0,0,1,.47.46,2.68,2.68,0,0,1,.34.7,4.65,4.65,0,0,1,.2.89,6.67,6.67,0,0,1,.07,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,217.86a.2.2,0,0,1,0,.08.05.05,0,0,1-.08,0l-.11-.06a.23.23,0,0,1-.07-.11.51.51,0,0,1,0-.17,1.06,1.06,0,0,1,0-.2l.41-1.73-1-5.48a1.84,1.84,0,0,1,0-.24.25.25,0,0,1,0-.13.05.05,0,0,1,.08,0l.11.06a.21.21,0,0,1,.08.1.57.57,0,0,1,0,.14l.89,4.82.91-3.78a.19.19,0,0,1,.05-.09s0,0,.08,0l.1.06a.24.24,0,0,1,.08.11.55.55,0,0,1,0,.17,1.06,1.06,0,0,1,0,.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.52,119.1c-3.45-2.73-4.41-1.39-4.39,2.06a15.44,15.44,0,0,1-.52,4.28,7.86,7.86,0,0,0-.83-2,1.49,1.49,0,0,0-1.93-.68c-.29.16.17.83.28,2.16.15,1.69-.29,2.69.32,4.43a2.9,2.9,0,0,1-.06,2c-1.18,3-5.3,7.93-8.48,12.21-2.45-2.83-8.72-10.09-11.13-13.05-4.16-5.09-5.43-7.3-10.15-7.69a12.46,12.46,0,0,1,3.61,3c1.88,2.16-.25,12.55-.25,12.55s14.29,14,15.77,15.34a6.88,6.88,0,0,0,1.4.93,4,4,0,0,0,4.72-1.51A129.22,129.22,0,0,0,360.14,136c1.13-2.64,2.36-4.72,3-6.46C365.33,123.52,364.68,120.82,362.52,119.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,122.63a8.13,8.13,0,0,1,6.22,2.58c2.43,2.51,12.49,15.1,12.49,15.1a10.6,10.6,0,0,1-7,8.25L325,136.18Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,122.63a8.13,8.13,0,0,1,6.22,2.58c2.43,2.51,12.49,15.1,12.49,15.1a10.6,10.6,0,0,1-7,8.25L325,136.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.25,
    y: 252.82,
    width: 6.17,
    height: 11.01,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.66 252.24 331.83 252.46 332.14 240.81 325.66 240.58 325.66 252.24",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,157.51c0,6.14.91,55.56.91,55.56-.15,1.76-1.74,5-1.39,11.81.47,9.22,1.09,33.45,1.09,33.45a7.84,7.84,0,0,0,6.87.14s5.84-33.56,6.95-42.69c1-8,2.6-34.83,2.6-34.83l3.35,31.22a37.84,37.84,0,0,0-.76,10.22c.28,4.23,2.27,26.24,2.27,26.24a8.15,8.15,0,0,0,7.13.56s3.51-33.14,3.58-37c.08-4.42-2.05-54.73-2.05-54.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,260.66v-.92c.59.27,2,5.72,4.41,8.05,2,1.85,4.61,4,5.28,6s-3.7,3.33-5.52,3c-2.11-.39-5.78-1.94-6.7-3.38s-1.35-3.55-2.1-4.61-2.47-2.23-2.87-3.45a8.11,8.11,0,0,1,.35-3.37c.29-1.14.6-2.39,1-2.28v.7a4.78,4.78,0,0,0,3.09,1.09C308.24,261.56,310.43,261.37,310.43,260.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.9,250.47c.32,0,.58.49,1.29,1.28a13.12,13.12,0,0,0,3.63,2.72c2.31,1.21,6.81,3.06,8.84,4,1.27.6,1.21,2.19-.1,3.1s-4.49,1.57-8.3.68c-2.07-.48-4.77-2.48-6.48-2.37s-4.91.08-6.17-.82-.76-2.84-.4-4.51.87-4.64,1.45-4.52v.63c.74,1.17,4.57,1.65,6.2.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.41,181a22.48,22.48,0,0,0,8.6-5.13s-1.66,3.24-6.59,6.25l1.06,27.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,123.73s-4.62.72-4.27,9.93l1.07,14.66-.11,22c4.55,5.15,24.67,4.77,31.57-.41,0,0-.71-26-1.18-36.06-.33-7.12-2-10.71-9-11.5l-8.91-.7Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,102.48a9.2,9.2,0,1,0,9.2-9.57A9.4,9.4,0,0,0,315,102.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.64,106.87a82,82,0,0,0,2,8,3,3,0,0,0,1.74,1.46l-.1-4.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,97s-1-.25-2.09,1.42c-.92,1.44-1.13,4.67.32,8.46l2.65.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,107.19c-.53.33-1.29-.73-1.95-1.45a2.27,2.27,0,0,0-3.87.66c-1.09,2.39,1,5.41,2.63,6.1a2.61,2.61,0,0,0,3.35-1l.22,12.07c3.86,6,12.61,5.75,9.46-.29v-4.47a17.39,17.39,0,0,0,3.92.21c2.14-.34,3.48-2.1,4.13-4.51,1-3.88,1.44-7,.55-14.62-1-8.35-10.29-8.44-15.32-5.14S312.09,107.19,312.09,107.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,108.13c-.27,0-1.29-1.76-1.95-2.39-.92-.87.27-8.75.27-8.75a3.84,3.84,0,0,1,.88-4c1.26-1.44,3.37-1.6,7-2.19A38.23,38.23,0,0,0,322.5,90,25.36,25.36,0,0,0,326.76,88a2.09,2.09,0,0,1,1.44-.33,1.4,1.4,0,0,1,.91,1,4.15,4.15,0,0,1,0,1.45,2.34,2.34,0,0,1,3.31.12,3.37,3.37,0,0,1,.51,3.48,6.24,6.24,0,0,1-2.41,2.76c-4.51,3-9.83,2.2-14.89,1.6a1.26,1.26,0,0,0-.72,0c-.79.35-1,2.81-1.09,3.52C313.38,104.05,313,108.11,312.09,108.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,97.4l-3.22-1.8a1.75,1.75,0,0,1,2.44-.84A2,2,0,0,1,310.41,97.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.93,118.82s-4.78-1-6.45-1.93a5.6,5.6,0,0,1-2.31-2.37,8.16,8.16,0,0,0,1.31,2.8c1.23,1.63,7.45,2.82,7.45,2.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.2,105.66a1,1,0,1,1-1-1A1,1,0,0,1,320.2,105.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.56,101.52l-2.05,1.18A1.31,1.31,0,0,1,317,101,1.13,1.13,0,0,1,318.56,101.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.49,112.83l2.19.86a1.14,1.14,0,0,1-1.49.75A1.29,1.29,0,0,1,321.49,112.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.76,102.48l-2.15-1a1.1,1.1,0,0,1,1.52-.61A1.32,1.32,0,0,1,329.76,102.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69,105.66a1,1,0,0,1-.95,1,1,1,0,0,1,0-2.07A1,1,0,0,1,328.69,105.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.92 104.92 323.03 110.97 326.46 110.18 322.92 104.92",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9,103.2a2.55,2.55,0,0,0,0,5.09h.46a2.55,2.55,0,0,0,0-5.09Zm-3,2.54a3,3,0,0,1,3-3.06h.46a3.06,3.06,0,0,1,0,6.12h-.46A3,3,0,0,1,315.9,105.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,103.2a2.55,2.55,0,0,0,0,5.09h.46a2.55,2.55,0,0,0,0-5.09Zm-3,2.54a3,3,0,0,1,3-3.06h.46a3.06,3.06,0,0,1,0,6.12h-.46A3,3,0,0,1,325.06,105.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.33,105.14a2,2,0,0,1,1.59-.83,1.58,1.58,0,0,1,1.38.54l.41-.32a2.09,2.09,0,0,0-1.82-.73,2.42,2.42,0,0,0-2,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.81,105.45h6.35V105h-7.43A3,3,0,0,1,309.81,105.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,144.68c1.94-4.9,3.63-8.78,5.82-13.41,2.33-4.92,3.66-7.13,8.17-7.31a29.9,29.9,0,0,1,.81,9.25c-.1,2.86-3,7.62-3,7.62s-6.68,11.29-8.05,12.75a5.21,5.21,0,0,1-2,1.69",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,123.73s-5-.3-6.84,3c-2.33,4.16-7,14.83-7,14.83s3.79,4.37,8.27,5.53c0,0,4.38-8.24,5.59-11A21.3,21.3,0,0,0,306.38,123.73Z",
    style: {
      fill: "#046CF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,123.73s-5-.3-6.84,3c-2.33,4.16-7,14.83-7,14.83s3.79,4.37,8.27,5.53c0,0,4.38-8.24,5.59-11A21.3,21.3,0,0,0,306.38,123.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.52,155.27a4,4,0,0,1-4.79-1.28c-3.18-4.21-9.28-13.78-11.91-18a53.2,53.2,0,0,1-3.44-6.19c-2.49-5.92-2-8.66.1-10.47,3.32-2.89,4.34-1.6,4.48,1.84a15.4,15.4,0,0,0,.74,4.25,8,8,0,0,1,.72-2,1.51,1.51,0,0,1,1.9-.77c.3.15-.13.85-.18,2.17-.06,1.7.42,2.68-.1,4.45a3,3,0,0,0,.41,2c1.45,3.21,7.47,10,11.5,14.13",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.09,126.62H284.72a.75.75,0,0,1,0-1.5h66.37a.75.75,0,0,1,0,1.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.92,130.46a.75.75,0,0,1-.44-1.36l4.48-3.23-4.48-3.24a.75.75,0,0,1-.17-1,.76.76,0,0,1,1.05-.17l5.32,3.85a.77.77,0,0,1,.31.61.75.75,0,0,1-.31.6l-5.32,3.85A.74.74,0,0,1,346.92,130.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,130.46a.74.74,0,0,1-.44-.14l-5.32-3.85a.75.75,0,0,1-.31-.6.77.77,0,0,1,.31-.61l5.32-3.85a.76.76,0,0,1,1,.17.75.75,0,0,1-.17,1L286,125.87l4.48,3.23a.75.75,0,0,1-.44,1.36Z",
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.0933301219b026b666cb2a148b0deacc.svg";
export { ForwardRef as ReactComponent };